(function() { window.GUID_5f9b9213_0fb0_4867_9d8e_6b25dfe9a04f = { getGuid: function() { return "5f9b9213-0fb0-4867-9d8e-6b25dfe9a04f"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        let ChartState;
        (function (ChartState) {
            ChartState["Initializing"] = "initializing";
            ChartState["Unready"] = "unready";
            ChartState["Ready"] = "ready";
            ChartState["Running"] = "running";
            ChartState["Stopping"] = "stopping";
            ChartState["Stopped"] = "stopped";
            ChartState["Error"] = "error";
            ChartState["Finished"] = "finished";
            ChartState["Destroying"] = "destroying";
            ChartState["Loading"] = "loading";
        })(ChartState || (ChartState = {}));
        class CSRChart extends Controls.ControlBase {
            get defaultXAxisScopes() {
                return [
                    {
                        value: this.minimumVisibleXAxisTicks,
                        label: CS.Helper.formatString(JSRess.XWeeks, this.minimumVisibleXAxisTicks),
                    },
                    {
                        value: 24,
                        label: CS.Helper.formatString(JSRess.XWeeks, 24),
                    },
                    {
                        value: 32,
                        label: CS.Helper.formatString(JSRess.XWeeks, 32),
                    },
                    {
                        value: 52,
                        label: CS.Helper.formatString(JSRess.XWeeks, 52),
                    },
                ];
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnBindEvents() { }
            OnDispose() {
                CS.DOM.$win.off(`resize.${this.ControlId}`);
            }
            get lang() {
                var _a, _b;
                return (_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.Language) !== null && _b !== void 0 ? _b : "en";
            }
            get mainPointRadius() {
                return this.visibleXAxisTicks > this.minimumVisibleXAxisTicks
                    ? 1
                    : this._mainPointRadius;
            }
            get secondaryPointRadius() {
                return this.visibleXAxisTicks > this.minimumVisibleXAxisTicks
                    ? 0.5
                    : this._secondaryPointRadius;
            }
            get isMobile() {
                return window.innerWidth < 600;
            }
            get chartInnerHeight() {
                return this.isMobile ? 350 : 400;
            }
            get chartMarginBottom() {
                return this.fontSizeX * 7;
            }
            get chartMarginLeft() {
                return this.fontSizeY * 3.5;
            }
            get chartOuterWidth() {
                return (this.chartInnerWidth - this.chartMarginLeft - this.chartMarginRight);
            }
            get chartOuterHeight() {
                return (this.chartInnerHeight - this.chartMarginTop - this.chartMarginBottom);
            }
            get selectedDatapoints() {
                return Object.keys(this.selectedDatapointsByEntityBaseId)
                    .reduce((acc, key) => {
                    acc.push(...this.selectedDatapointsByEntityBaseId[key]);
                    return acc;
                }, [])
                    .sort((a, b) => {
                    return a.timestamp - b.timestamp;
                });
            }
            get lastSelectedDatapoint() {
                return this.selectedDatapoints[this.selectedDatapoints.length - 1];
            }
            get selectedTimestamp() {
                var _a;
                return (_a = this.lastSelectedDatapoint) === null || _a === void 0 ? void 0 : _a.timestamp;
            }
            get minimumVisibleXAxisTicks() {
                return this.hasMultiplePlayers
                    ? this._minimumVisibleXAxisTicksForMultiplePlayers
                    : this._minimumVisibleXAxisTicksForOnePlayer;
            }
            get visibleXAxisTicks() {
                return this._visibleXAxisTicks;
            }
            set visibleXAxisTicks(value) {
                this._visibleXAxisTicks = value;
                this.hoveredPointRadius =
                    this.visibleXAxisTicks > this.minimumVisibleXAxisTicks
                        ? this._mainPointRadius * 2
                        : this.mainPointRadius * 2;
            }
            // public highlightedWeekIndex: number;
            constructor(controlId, id, statUserGraphs, valueFormatter, forcedMin, forcedMax, preventInteraction, itsMe, forceAllTime, onlyGraph) {
                super(controlId);
                this.controlId = controlId;
                this.id = id;
                this.statUserGraphs = statUserGraphs;
                this.valueFormatter = valueFormatter;
                this.forcedMin = forcedMin;
                this.forcedMax = forcedMax;
                this.preventInteraction = preventInteraction;
                this.itsMe = itsMe;
                this.forceAllTime = forceAllTime;
                this.onlyGraph = onlyGraph;
                this.bisect = null;
                this.state = ChartState.Ready;
                this.rootElement = null;
                this.containerElement = null;
                this.controlsElement = null;
                this.weekSelectionElement = null;
                this.selectNumberOfDatapointsElement = null;
                this.innerContainerElement = null;
                this.innerChartContainerElement = null;
                this.innerChartElement = null;
                this.series = [];
                this.seriesByEntityBaseId = {};
                this.datapointsBySymbol = {};
                this.datapointsByEntityBaseId = {};
                this.allData = [];
                this.data = [];
                this.datapointsByDate = {};
                this.placeholderCSRDatapoints = [];
                this.yScale = null;
                this.domainLineColor = "hsl(0, 0%, 50%)";
                this.lastDateIsMissingDatapoins = false;
                this.lastValueIsCurrent = false;
                this.numberOfTCSRDatapointsToGetCSR = 12;
                this.svg = null;
                this.xScale = null;
                this.anyNegativeValues = false;
                this.serie = null;
                this.strokeWidthCSR = 4;
                this.strokeWidthDashedLine = 1;
                this.strokeWidthTCSRSmall = 1;
                this.strokeWidthTCSRLarge = 2;
                this._mainPointRadius = 4;
                this.hoveredPointRadius = this.mainPointRadius * 2;
                this._secondaryPointRadius = 2.5;
                this.symbols = [];
                this.tooltipV2 = null;
                this.svgOverlay = null;
                this.chartOverlayElement = null;
                this.mainCSRColor = CS.Helper.DataVisualizationHelper.MUI_PALETTE.yellow[600];
                this.mainTCSRColor = CS.Helper.DataVisualizationHelper.MUI_PALETTE.yellow[200];
                this.secondaryCSRColor = CS.Helper.DataVisualizationHelper.MUI_PALETTE.blue[600];
                this.secondaryTCSRColor = CS.Helper.DataVisualizationHelper.MUI_PALETTE.blue[200];
                this.hasMultiplePlayers = false;
                this.chartInnerWidth = 0;
                this.chartMarginRight = 0;
                this.chartMarginTop = 8;
                this.textColorX = "rgba(255, 255, 255, 0.5)";
                this.textColorY = "rgba(255, 255, 255, 0.7)";
                this.allWeeks = [];
                this.weeks = [];
                this.weeksByEntityBaseId = {};
                this.selectedDatapointsByEntityBaseId = {};
                this._minimumVisibleXAxisTicksForOnePlayer = 13;
                this._minimumVisibleXAxisTicksForMultiplePlayers = 15;
                this._visibleXAxisTicks = this._minimumVisibleXAxisTicksForOnePlayer;
                this.resizeTimeout = null;
                if (!this.valueFormatter) {
                    this.valueFormatter = (value) => {
                        return value.toString();
                    };
                }
                this.setFontSizes();
            }
            setFontSizes() {
                let bodyFontSize = window
                    .getComputedStyle(document.body)
                    .getPropertyValue("font-size");
                if (bodyFontSize && bodyFontSize.endsWith("px")) {
                    bodyFontSize = bodyFontSize.slice(0, -2);
                }
                if (bodyFontSize) {
                    const fontSizeXMultiplier = 0.7;
                    const fontSizeYMultiplier = 0.8;
                    const fontSize = Number(bodyFontSize);
                    this.fontSizeX = fontSize * fontSizeXMultiplier;
                    this.fontSizeY = fontSize * fontSizeYMultiplier;
                }
                else {
                    this.fontSizeX = 12;
                    this.fontSizeY = 16;
                }
            }
            init() {
                return __awaiter(this, void 0, void 0, function* () {
                    yield this.initialize();
                    setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                        yield this.handleResize();
                    }), 100);
                });
            }
            setMarginTop() {
                try {
                    if (!this.data.length) {
                        return;
                    }
                    const hasFrozenCSR = this.data.some((datapoint) => {
                        return datapoint.hasFrozenCsr;
                    });
                    if (hasFrozenCSR) {
                        this.chartMarginTop = 32;
                    }
                    else {
                        this.chartMarginTop = 8;
                    }
                }
                catch (error) {
                    console.error("Error while setting margin top.", error);
                }
            }
            initialize() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.setAllWeeks();
                        this.setHasMultiplePlayers();
                        this.setXAxisScopes();
                        this.setWeeks();
                        // this.setVisibleXAxisTicksCount();
                        this.setData();
                        this.setPointRadiusOfEachDatapoint();
                        this.setPlaceholderCSRDatapoints();
                        this.setPalette();
                        this.createHTML();
                        this.setMarginTop();
                        yield this.setChartDimensions();
                        this.setSelectOptions();
                        this.setSelectedDatapoints();
                        this.setSeries();
                        this.render()
                            .then(() => {
                            if (this.weekSelectionElement) {
                                const timestamp = this.lastSelectedDatapoint.timestamp;
                                this.weekSelectionElement.value =
                                    timestamp.toString();
                            }
                            this.setState(ChartState.Ready);
                        })
                            .catch((error) => {
                            console.error(error);
                            this.setState(ChartState.Error);
                        });
                    }
                    catch (error) {
                        console.error(error);
                        this.setState(ChartState.Error);
                    }
                });
            }
            // private setVisibleXAxisTicksCount(value?: number) {
            //   try {
            //     if (value) {
            //       this.visibleXAxisTicks = value;
            //       return;
            //     }
            //     if (this.weeks.length < this.xAxisScope) {
            //       this._visibleXAxisTicks = this.weeks.length;
            //     }
            //     if (this.weeks.length < this.xAxisScope) {
            //       this._visibleXAxisTicks = this.weeks.length;
            //     }
            //     this.visibleXAxisTicks = this.minimumVisibleXAxisTicks;
            //   } catch (error) {
            //     console.error("Error while setting visible x axis ticks count.", error);
            //   }
            // }
            setXAxisScopes() {
                try {
                    const xAxisScopes = [];
                    for (let i = 0; i < this.defaultXAxisScopes.length; i++) {
                        const item = this.defaultXAxisScopes[i];
                        const isValid = this.allWeeks.length >= item.value;
                        if (isValid) {
                            xAxisScopes.push(item);
                        }
                    }
                    if (xAxisScopes.length === 0) {
                        if (this.allWeeks.length > 0) {
                            xAxisScopes.push({
                                value: this.allWeeks.length,
                                label: JSRess.AllTime,
                            });
                        }
                    }
                    if (xAxisScopes.length === 0) {
                        throw new Error("No valid x axis scopes found.");
                    }
                    const lastItem = xAxisScopes[xAxisScopes.length - 1];
                    if (this.allWeeks.length > lastItem.value) {
                        xAxisScopes.push({
                            value: this.allWeeks.length,
                            label: JSRess.AllTime,
                        });
                    }
                    if (this.xAxisScope == null) {
                        if (this.forceAllTime) {
                            this.xAxisScope = xAxisScopes[xAxisScopes.length - 1].value;
                        }
                        else {
                            this.xAxisScope = xAxisScopes[0].value;
                        }
                    }
                    this.xAxisScopes = xAxisScopes;
                    this.visibleXAxisTicks = this.xAxisScope;
                }
                catch (error) {
                    console.error("Error while setting x axis scopes.", error);
                }
            }
            setWeeks() {
                try {
                    this.weeks = this.allWeeks.slice(-this.xAxisScope);
                }
                catch (error) {
                    console.error("Error while setting weeks.", error);
                }
            }
            setAllWeeks() {
                try {
                    this.allWeeks = this.statUserGraphs
                        .map((datapoint) => {
                        return {
                            timestamp: datapoint.StatDateTimestamp,
                            date: new Date(datapoint.StatDateString),
                        };
                    })
                        .filter((value, index, self) => {
                        return (self.findIndex((v) => v.timestamp === value.timestamp) === index);
                    })
                        .sort((a, b) => {
                        return a.timestamp - b.timestamp;
                    });
                }
                catch (error) {
                    console.error("Error while setting weeks.", error);
                }
            }
            setHasMultiplePlayers() {
                try {
                    const entityBaseIds = this.statUserGraphs
                        .map((datapoint) => {
                        return datapoint.EntityBaseId.toString();
                    })
                        .filter((value, index, self) => {
                        return self.indexOf(value) === index;
                    });
                    this.hasMultiplePlayers = entityBaseIds.length > 1;
                }
                catch (error) {
                    console.error("Error while setting has multiple players.", error);
                }
            }
            setData() {
                try {
                    if (this.statUserGraphs == null) {
                        throw new Error("Data not found.");
                    }
                    this.entityBaseIds = this.statUserGraphs
                        .map((datapoint) => {
                        return datapoint.EntityBaseId.toString();
                    })
                        .filter((value, index, self) => {
                        return self.indexOf(value) === index;
                    });
                    if (this.entityBaseIds.length > 1) {
                        this.hasMultiplePlayers = true;
                    }
                    this.allData = this.statUserGraphs
                        .map((datapoint, index) => {
                        const date = new Date(datapoint.StatDateString);
                        const timestamp = datapoint.StatDateTimestamp;
                        const statName = this.getStatName(datapoint.StatFieldId);
                        const result = {
                            id: timestamp.toString(),
                            symbol: `${datapoint.EntityBaseId}-${datapoint.StatFieldId}`,
                            label: CS.Helper.formatString(JSRess.YOfX, datapoint.DisplayName, statName),
                            displayName: datapoint.DisplayName,
                            date: date,
                            timestamp: timestamp,
                            entityBaseId: datapoint.EntityBaseId.toString(),
                            value: datapoint.Value,
                            statName: statName,
                            image: "",
                            color: "",
                            areaColor: "",
                            lineColor: "",
                            mainPointColor: "",
                            secondaryPointColor: "",
                            pointRadius: datapoint.StatFieldId === "CompuSportRating"
                                ? this.mainPointRadius
                                : this.secondaryPointRadius,
                            premiumLocked: datapoint.PremiumLocked,
                            hasFrozenCsr: datapoint.HasFrozenCsr,
                            frozenCsrEventId: datapoint.FrozenCsrEventId,
                            frozenCsrEventImageUrl: datapoint.FrozenCsrEventImageUrl,
                            frozenCsrEventName: datapoint.FrozenCsrEventName,
                            frozenCsrTooltipLabel: datapoint.FrozenCsrTooltipLabel,
                        };
                        return result;
                    })
                        .sort((a, b) => {
                        return a.timestamp - b.timestamp;
                    });
                    this.data = this.statUserGraphs
                        .filter((datapoint) => {
                        return this.weeks[0].timestamp <= datapoint.StatDateTimestamp;
                    })
                        .map((datapoint, index) => {
                        const date = new Date(datapoint.StatDateString);
                        const timestamp = datapoint.StatDateTimestamp;
                        const statName = this.getStatName(datapoint.StatFieldId);
                        const result = {
                            id: timestamp.toString(),
                            symbol: `${datapoint.EntityBaseId}-${datapoint.StatFieldId}`,
                            label: CS.Helper.formatString(JSRess.YOfX, datapoint.DisplayName, statName),
                            displayName: datapoint.DisplayName,
                            date: date,
                            timestamp: timestamp,
                            entityBaseId: datapoint.EntityBaseId.toString(),
                            value: datapoint.Value,
                            statName: statName,
                            image: "",
                            color: "",
                            areaColor: "",
                            lineColor: "",
                            mainPointColor: "",
                            secondaryPointColor: "",
                            pointRadius: datapoint.StatFieldId === "CompuSportRating"
                                ? this.mainPointRadius
                                : this.secondaryPointRadius,
                            premiumLocked: datapoint.PremiumLocked,
                            hasFrozenCsr: datapoint.HasFrozenCsr,
                            frozenCsrEventId: datapoint.FrozenCsrEventId,
                            frozenCsrEventImageUrl: datapoint.FrozenCsrEventImageUrl,
                            frozenCsrEventName: datapoint.FrozenCsrEventName,
                            frozenCsrTooltipLabel: datapoint.FrozenCsrTooltipLabel,
                        };
                        return result;
                    })
                        .sort((a, b) => {
                        return a.timestamp - b.timestamp;
                    });
                    const reducedList = this.data.map((datapoint) => {
                        return {
                            entityBaseId: datapoint.entityBaseId,
                            displayName: datapoint.displayName,
                            label: datapoint.label,
                        };
                    });
                    this.addCurrentCSRDatapointIfNeeded();
                    const timestamps = [];
                    const symbols = [];
                    const entityBaseIds = [];
                    this.data.forEach((datapoint) => {
                        const symbol = datapoint.symbol;
                        const entityBaseId = datapoint.entityBaseId;
                        if (!symbols.includes(symbol)) {
                            const _datapointsOfSameSymbol = this.data.filter((d) => {
                                return d.symbol === datapoint.symbol;
                            });
                            const datapointsOfSameSymbol = _datapointsOfSameSymbol !== null && _datapointsOfSameSymbol !== void 0 ? _datapointsOfSameSymbol : [];
                            this.datapointsBySymbol[symbol] = datapointsOfSameSymbol !== null && datapointsOfSameSymbol !== void 0 ? datapointsOfSameSymbol : [];
                            symbols.push(symbol);
                            // const weeks = datapointsOfSameSymbol
                            //   .reduce((acc, datapoint) => {
                            //     const timestamp = datapoint.timestamp;
                            //     if (!acc.find((w) => w.timestamp === timestamp)) {
                            //       acc.push({
                            //         timestamp: timestamp,
                            //         date: datapoint.date,
                            //       });
                            //     }
                            //     return acc;
                            //   }, [] as CSRChartWeek[])
                            //   .sort((a, b) => {
                            //     return a.timestamp - b.timestamp;
                            //   });
                        }
                        if (!entityBaseIds.includes(entityBaseId)) {
                            const _datapointsOfSameEntityBaseId = this.data.filter((d) => {
                                return d.entityBaseId === entityBaseId;
                            });
                            const datapointsOfSameEntityBaseId = _datapointsOfSameEntityBaseId !== null && _datapointsOfSameEntityBaseId !== void 0 ? _datapointsOfSameEntityBaseId : [];
                            this.datapointsByEntityBaseId[entityBaseId] =
                                datapointsOfSameEntityBaseId !== null && datapointsOfSameEntityBaseId !== void 0 ? datapointsOfSameEntityBaseId : [];
                            entityBaseIds.push(entityBaseId);
                            const weeks = datapointsOfSameEntityBaseId
                                .reduce((acc, datapoint) => {
                                const timestamp = datapoint.timestamp;
                                if (!acc.find((w) => w.timestamp === timestamp)) {
                                    acc.push({
                                        timestamp: timestamp,
                                        date: datapoint.date,
                                    });
                                }
                                return acc;
                            }, [])
                                .sort((a, b) => {
                                return a.timestamp - b.timestamp;
                            });
                            this.weeksByEntityBaseId[entityBaseId] = weeks;
                        }
                        const timestamp = datapoint.timestamp;
                        if (!timestamps.includes(timestamp)) {
                            const datapointsOfSameDate = this.data.filter((d) => {
                                return d.timestamp === datapoint.timestamp;
                            });
                            this.datapointsByDate[timestamp] = datapointsOfSameDate !== null && datapointsOfSameDate !== void 0 ? datapointsOfSameDate : [];
                            timestamps.push(timestamp);
                        }
                    });
                    Object.keys(this.datapointsBySymbol).forEach((symbol, i) => {
                        let value = null;
                        const lastDatapoint = this.datapointsBySymbol[symbol][this.datapointsBySymbol[symbol].length - 1];
                        if (lastDatapoint.isCurrent &&
                            this.datapointsBySymbol[symbol].length > 1) {
                            const beforeLastDatapoint = this.datapointsBySymbol[symbol][this.datapointsBySymbol[symbol].length - 2];
                            value = beforeLastDatapoint.value;
                        }
                        else {
                            value = lastDatapoint.value;
                        }
                        this.symbols.push({
                            id: symbol,
                            name: this.datapointsBySymbol[symbol][0].label,
                            statName: this.datapointsBySymbol[symbol][0].statName,
                            entityName: this.datapointsBySymbol[symbol][0].displayName,
                            value: value,
                            color: "",
                            areaColor: "",
                            lineColor: "",
                            mainPointColor: "",
                            secondaryPointColor: "",
                            entityBaseId: this.datapointsBySymbol[symbol][0].entityBaseId,
                            premiumLocked: this.datapointsBySymbol[symbol][0].premiumLocked,
                        });
                    });
                    this.symbols.sort((a, b) => {
                        return b.value - a.value;
                    });
                }
                catch (error) {
                    console.error("Error while parsing data.", error);
                }
            }
            resetData() {
                try {
                    this.data = [];
                    this.series = [];
                    this.seriesByEntityBaseId = {};
                    this.datapointsBySymbol = {};
                    this.datapointsByEntityBaseId = {};
                    this.datapointsByDate = {};
                    this.placeholderCSRDatapoints = [];
                    this.symbols = [];
                    this.selectedDatapointsByEntityBaseId = {};
                    this.weeksByEntityBaseId = {};
                    this.weeks = [];
                }
                catch (error) {
                    console.error("Error while resetting data.", error);
                }
            }
            setPointRadiusOfEachDatapoint() {
                try {
                    this.data.forEach((datapoint, i) => {
                        if (datapoint.statName === "CompuSportRating") {
                            datapoint.pointRadius = this.mainPointRadius;
                        }
                        else {
                            datapoint.pointRadius = this.secondaryPointRadius;
                        }
                    });
                    Object.keys(this.datapointsBySymbol).forEach((symbol, i) => {
                        const datapoints = this.datapointsBySymbol[symbol];
                        const lastDatapoint = datapoints[datapoints.length - 1];
                        if (lastDatapoint.isCurrent && datapoints.length > 1) {
                            const beforeLastDatapoint = datapoints[datapoints.length - 2];
                            beforeLastDatapoint.pointRadius = this.mainPointRadius;
                        }
                    });
                    Object.keys(this.datapointsByEntityBaseId).forEach((entityBaseId, i) => {
                        const datapoints = this.datapointsByEntityBaseId[entityBaseId];
                        const lastDatapoint = datapoints[datapoints.length - 1];
                        if (lastDatapoint.isCurrent && datapoints.length > 1) {
                            const beforeLastDatapoint = datapoints[datapoints.length - 2];
                            beforeLastDatapoint.pointRadius = this.mainPointRadius;
                        }
                    });
                    Object.keys(this.datapointsByDate).forEach((timestamp, i) => {
                        const datapoints = this.datapointsByDate[timestamp];
                        const lastDatapoint = datapoints[datapoints.length - 1];
                        if (lastDatapoint.isCurrent && datapoints.length > 1) {
                            const beforeLastDatapoint = datapoints[datapoints.length - 2];
                            beforeLastDatapoint.pointRadius = this.mainPointRadius;
                        }
                    });
                }
                catch (error) {
                    console.error("Error while setting point radius.", error);
                }
            }
            setSeries() {
                try {
                    this.series = Object.keys(this.datapointsBySymbol).map((symbol) => {
                        const datapoints = this.datapointsBySymbol[symbol];
                        const values = datapoints.filter((datapoint) => {
                            return this.data.find((d) => d.id === datapoint.id);
                        });
                        return {
                            key: symbol,
                            values: values,
                        };
                    });
                    this.seriesByEntityBaseId = this.series.reduce((acc, serie) => {
                        const entityBaseId = serie.key.split("-")[0];
                        if (!acc[entityBaseId]) {
                            acc[entityBaseId] = [];
                        }
                        acc[entityBaseId].push(serie);
                        return acc;
                    }, {});
                }
                catch (error) {
                    console.error("Error while setting series.", error);
                    this.setState(ChartState.Error);
                }
            }
            setPlaceholderCSRDatapoints() {
                try {
                    const missingDatesByEntityBaseId = {};
                    this.weeks.forEach((week, i) => {
                        this.entityBaseIds.forEach((entityBaseId, j) => {
                            const datapointsOfEntity = this.datapointsByEntityBaseId[entityBaseId];
                            const timestampDatapointsOfEntity = datapointsOfEntity.filter((datapoint) => {
                                return datapoint.timestamp === week.timestamp;
                            });
                            if (!timestampDatapointsOfEntity.length) {
                                if (!missingDatesByEntityBaseId[entityBaseId]) {
                                    missingDatesByEntityBaseId[entityBaseId] = [];
                                }
                                missingDatesByEntityBaseId[entityBaseId].push(week);
                            }
                        });
                    });
                    const consecutiveDatesGroupsByEntityBaseId = {};
                    Object.keys(missingDatesByEntityBaseId).forEach((entityBaseId, i) => {
                        const missingDates = missingDatesByEntityBaseId[entityBaseId];
                        let consecutiveDates = [];
                        let consecutiveDatesGroups = [];
                        missingDates.forEach((date, i) => {
                            if (i === 0) {
                                consecutiveDates.push(date);
                            }
                            else {
                                const previousDate = missingDates[i - 1];
                                const previousDateIndex = this.weeks.findIndex((w) => w.timestamp === previousDate.timestamp);
                                const currentDate = date;
                                const currentDateIndex = this.weeks.findIndex((w) => w.timestamp === currentDate.timestamp);
                                const isConsecutive = currentDateIndex - previousDateIndex === 1;
                                if (isConsecutive) {
                                    consecutiveDates.push(date);
                                }
                                else {
                                    consecutiveDatesGroups.push(consecutiveDates);
                                    if (i === missingDates.length - 1) {
                                        consecutiveDatesGroups.push([date]);
                                    }
                                    else {
                                        consecutiveDates = [date];
                                    }
                                }
                            }
                            consecutiveDatesGroupsByEntityBaseId[entityBaseId] =
                                consecutiveDatesGroups;
                        });
                    });
                    const removeFirstGroupEntityBaseIds = [];
                    const removeLastGroupEntityBaseIds = [];
                    Object.keys(consecutiveDatesGroupsByEntityBaseId).forEach((entityBaseId) => {
                        const consecutiveDatesGroups = consecutiveDatesGroupsByEntityBaseId[entityBaseId];
                        if (!consecutiveDatesGroups || !consecutiveDatesGroups.length) {
                            return;
                        }
                        const firstGroup = consecutiveDatesGroups[0];
                        const lastGroup = consecutiveDatesGroups[consecutiveDatesGroups.length - 1];
                        const firstDate = firstGroup[0];
                        const lastDate = lastGroup[lastGroup.length - 1];
                        if (firstDate.timestamp === this.weeks[0].timestamp) {
                            removeFirstGroupEntityBaseIds.push(entityBaseId);
                        }
                        if (lastDate.timestamp === this.weeks[this.weeks.length - 1].timestamp) {
                            removeLastGroupEntityBaseIds.push(entityBaseId);
                        }
                    });
                    removeFirstGroupEntityBaseIds.forEach((entityBaseId) => {
                        consecutiveDatesGroupsByEntityBaseId[entityBaseId].shift();
                    });
                    removeLastGroupEntityBaseIds.forEach((entityBaseId) => {
                        consecutiveDatesGroupsByEntityBaseId[entityBaseId].pop();
                    });
                    Object.keys(consecutiveDatesGroupsByEntityBaseId).forEach((entityBaseId) => {
                        const consecutiveWeeksGroups = consecutiveDatesGroupsByEntityBaseId[entityBaseId];
                        consecutiveWeeksGroups.forEach((consecutiveWeeks, i) => {
                            const firstDate = consecutiveWeeks[0];
                            const lastDate = consecutiveWeeks[consecutiveWeeks.length - 1];
                            const indexOfFirstDate = this.weeks.findIndex((w) => w.timestamp === firstDate.timestamp);
                            const indexOfLastDate = this.weeks.findIndex((w) => w.timestamp === lastDate.timestamp);
                            const dateBefore = this.weeks[indexOfFirstDate - 1];
                            const dateAfter = this.weeks[indexOfLastDate + 1];
                            const csrDatapointBefore = this.datapointsByEntityBaseId[entityBaseId].find((d) => d.timestamp === dateBefore.timestamp);
                            const csrDatapointAfter = this.datapointsByEntityBaseId[entityBaseId].find((d) => d.timestamp === dateAfter.timestamp);
                            if (!csrDatapointBefore || !csrDatapointAfter) {
                                throw new Error("CSR datapoint before or after missing dates not found.");
                            }
                            const valueBefore = csrDatapointBefore.value;
                            const valueAfter = csrDatapointAfter.value;
                            const count = consecutiveWeeks.length;
                            for (let i = 0; i < count; i++) {
                                const value = valueBefore + (valueAfter - valueBefore) * (i / count);
                                const date = consecutiveWeeks[i];
                                const newDatapoint = Object.assign(Object.assign({}, csrDatapointBefore), { id: date.timestamp.toString(), date: date.date, timestamp: date.timestamp, value: value });
                                this.placeholderCSRDatapoints.push(newDatapoint);
                            }
                        });
                    });
                }
                catch (error) {
                    console.error("Error while setting placeholder CSR datapoints.", error);
                }
            }
            setPalette() {
                var _a;
                const getAreaColor = (color, stat) => {
                    const isRGB = color.startsWith("rgb");
                    const isHEX = color.startsWith("#");
                    let opacityRGBA;
                    let opacityHEX;
                    if (this.hasMultiplePlayers) {
                        if (stat === "TCSR") {
                            opacityRGBA = 0.05;
                            opacityHEX = "0D";
                        }
                        else {
                            opacityRGBA = 0.1;
                            opacityHEX = "1A";
                        }
                    }
                    else {
                        if (stat === "TCSR") {
                            opacityRGBA = 0.1;
                            opacityHEX = "1A";
                        }
                        else {
                            opacityRGBA = 0.25;
                            opacityHEX = "40";
                        }
                    }
                    if (isRGB) {
                        return color.replace("rgb", "rgba").replace(")", `, ${opacityRGBA})`);
                    }
                    else if (isHEX) {
                        return color + opacityHEX;
                    }
                    return color;
                };
                const getMainPointColor = (color, stat) => {
                    const isRGB = color.startsWith("rgb");
                    const isHEX = color.startsWith("#");
                    let opacityRGBA;
                    let opacityHEX;
                    opacityRGBA = 1;
                    opacityHEX = "FF";
                    if (isRGB) {
                        return color.replace("rgb", "rgba").replace(")", `, ${opacityRGBA})`);
                    }
                    else if (isHEX) {
                        return color + opacityHEX;
                    }
                    return color;
                };
                const getSecondaryPointColor = (color, stat) => {
                    const isRGB = color.startsWith("rgb");
                    const isHEX = color.startsWith("#");
                    let opacityRGBA;
                    let opacityHEX;
                    opacityRGBA = 0.35;
                    opacityHEX = "59";
                    if (isRGB) {
                        return color.replace("rgb", "rgba").replace(")", `, ${opacityRGBA})`);
                    }
                    else if (isHEX) {
                        return color + opacityHEX;
                    }
                    return color;
                };
                const getLineColor = (color, stat) => {
                    const isRGB = color.startsWith("rgb");
                    const isHEX = color.startsWith("#");
                    let opacityRGBA;
                    let opacityHEX;
                    if (this.hasMultiplePlayers) {
                        if (stat === "TCSR") {
                            opacityRGBA = 0.5;
                            opacityHEX = "80";
                        }
                        else {
                            opacityRGBA = 1;
                            opacityHEX = "FF";
                        }
                    }
                    else {
                        if (stat === "TCSR") {
                            opacityRGBA = 0.75;
                            opacityHEX = "BF";
                        }
                        else {
                            opacityRGBA = 1;
                            opacityHEX = "FF";
                        }
                    }
                    if (isRGB) {
                        return color.replace("rgb", "rgba").replace(")", `, ${opacityRGBA})`);
                    }
                    else if (isHEX) {
                        return color + opacityHEX;
                    }
                    return color;
                };
                this.symbols.sort((a, b) => {
                    if (a.id.includes("TCSR")) {
                        return 1;
                    }
                    if (b.id.includes("TCSR")) {
                        return -1;
                    }
                    return 0;
                });
                let addedEntityBaseIds = [];
                const symbolsByEntityBaseId = this.symbols
                    .map((symbol) => {
                    const entityBaseId = symbol.entityBaseId;
                    if (!addedEntityBaseIds.includes(entityBaseId)) {
                        addedEntityBaseIds.push(entityBaseId);
                        return {
                            [entityBaseId]: this.symbols.filter((s) => s.entityBaseId === entityBaseId),
                        };
                    }
                    return null;
                }, {})
                    .filter((obj) => obj != null)
                    .reduce((acc, obj) => {
                    return Object.assign(Object.assign({}, acc), obj);
                }, {});
                Object.keys(symbolsByEntityBaseId).forEach((entityBaseId, i) => {
                    const symbols = symbolsByEntityBaseId[entityBaseId];
                    const entityBaseIdIndex = this.entityBaseIds.indexOf(entityBaseId);
                    if (entityBaseIdIndex == -1) {
                        return;
                    }
                    if (entityBaseIdIndex <= 0) {
                        symbols.forEach((symbol, i) => {
                            var _a;
                            const isTCSRSymbol = symbol.id.includes("TCSR");
                            const matchingSymbol = this.symbols.find((s) => s.id === symbol.id);
                            const matchingSymbolIsPremiumLocked = (_a = matchingSymbol === null || matchingSymbol === void 0 ? void 0 : matchingSymbol.premiumLocked) !== null && _a !== void 0 ? _a : false;
                            if (isTCSRSymbol) {
                                if (matchingSymbolIsPremiumLocked) {
                                    matchingSymbol.color = "transparent";
                                    matchingSymbol.lineColor = "transparent";
                                    matchingSymbol.areaColor = "transparent";
                                    matchingSymbol.mainPointColor = "transparent";
                                    matchingSymbol.secondaryPointColor = "transparent";
                                }
                                else {
                                    matchingSymbol.color = this.mainTCSRColor;
                                    matchingSymbol.lineColor = getLineColor(this.mainTCSRColor, "TCSR");
                                    matchingSymbol.areaColor = getAreaColor(this.mainTCSRColor, "TCSR");
                                    matchingSymbol.mainPointColor = getMainPointColor(this.mainTCSRColor, "TCSR");
                                    matchingSymbol.secondaryPointColor = getSecondaryPointColor(this.mainTCSRColor, "TCSR");
                                }
                            }
                            else {
                                matchingSymbol.color = this.mainCSRColor;
                                matchingSymbol.lineColor = getLineColor(this.mainCSRColor, "CompuSportRating");
                                matchingSymbol.areaColor = getAreaColor(this.mainCSRColor, "CompuSportRating");
                                matchingSymbol.mainPointColor = getMainPointColor(this.mainCSRColor, "CompuSportRating");
                                matchingSymbol.secondaryPointColor = getSecondaryPointColor(this.mainCSRColor, "CompuSportRating");
                            }
                        });
                    }
                    else {
                        symbols.forEach((symbol, i) => {
                            var _a;
                            const isTCSRSymbol = symbol.id.includes("TCSR");
                            const matchingSymbol = this.symbols.find((s) => s.id === symbol.id);
                            const matchingSymbolIsPremiumLocked = (_a = matchingSymbol === null || matchingSymbol === void 0 ? void 0 : matchingSymbol.premiumLocked) !== null && _a !== void 0 ? _a : false;
                            if (isTCSRSymbol) {
                                if (matchingSymbolIsPremiumLocked) {
                                    matchingSymbol.color = "transparent";
                                    matchingSymbol.lineColor = "transparent";
                                    matchingSymbol.areaColor = "transparent";
                                    matchingSymbol.mainPointColor = "transparent";
                                    matchingSymbol.secondaryPointColor = "transparent";
                                }
                                else {
                                    matchingSymbol.color = this.secondaryTCSRColor;
                                    matchingSymbol.lineColor = getLineColor(this.secondaryTCSRColor, "TCSR");
                                    matchingSymbol.areaColor = getAreaColor(this.secondaryTCSRColor, "TCSR");
                                    matchingSymbol.mainPointColor = getMainPointColor(this.secondaryTCSRColor, "TCSR");
                                    matchingSymbol.secondaryPointColor = getSecondaryPointColor(this.secondaryTCSRColor, "TCSR");
                                }
                            }
                            else {
                                matchingSymbol.color = this.secondaryCSRColor;
                                matchingSymbol.lineColor = getLineColor(this.secondaryCSRColor, "CompuSportRating");
                                matchingSymbol.areaColor = getAreaColor(this.secondaryCSRColor, "CompuSportRating");
                                matchingSymbol.mainPointColor = getMainPointColor(this.secondaryCSRColor, "CompuSportRating");
                                matchingSymbol.secondaryPointColor = getSecondaryPointColor(this.secondaryCSRColor, "CompuSportRating");
                            }
                        });
                    }
                });
                ((_a = this.data) !== null && _a !== void 0 ? _a : []).forEach((datapoint, i) => {
                    var _a, _b, _c, _d, _e;
                    const symbol = this.symbols.find((s) => s.id === datapoint.symbol);
                    datapoint.color = (_a = symbol === null || symbol === void 0 ? void 0 : symbol.color) !== null && _a !== void 0 ? _a : "";
                    datapoint.lineColor = (_b = symbol === null || symbol === void 0 ? void 0 : symbol.lineColor) !== null && _b !== void 0 ? _b : "";
                    datapoint.areaColor = (_c = symbol === null || symbol === void 0 ? void 0 : symbol.areaColor) !== null && _c !== void 0 ? _c : "";
                    datapoint.mainPointColor = (_d = symbol === null || symbol === void 0 ? void 0 : symbol.mainPointColor) !== null && _d !== void 0 ? _d : "";
                    datapoint.secondaryPointColor = (_e = symbol === null || symbol === void 0 ? void 0 : symbol.secondaryPointColor) !== null && _e !== void 0 ? _e : "";
                });
                this.series.forEach((serie, i) => {
                    serie.values.forEach((datapoint, j) => {
                        var _a, _b, _c, _d, _e;
                        const symbol = this.symbols.find((s) => s.id === datapoint.symbol);
                        datapoint.color = (_a = symbol === null || symbol === void 0 ? void 0 : symbol.color) !== null && _a !== void 0 ? _a : "";
                        datapoint.lineColor = (_b = symbol === null || symbol === void 0 ? void 0 : symbol.lineColor) !== null && _b !== void 0 ? _b : "";
                        datapoint.areaColor = (_c = symbol === null || symbol === void 0 ? void 0 : symbol.areaColor) !== null && _c !== void 0 ? _c : "";
                        datapoint.mainPointColor = (_d = symbol === null || symbol === void 0 ? void 0 : symbol.mainPointColor) !== null && _d !== void 0 ? _d : "";
                        datapoint.secondaryPointColor = (_e = symbol === null || symbol === void 0 ? void 0 : symbol.secondaryPointColor) !== null && _e !== void 0 ? _e : "";
                    });
                });
                this.data.forEach((datapoint, i) => {
                    var _a, _b, _c, _d, _e;
                    const symbol = this.symbols.find((s) => s.id === datapoint.symbol);
                    datapoint.color = (_a = symbol === null || symbol === void 0 ? void 0 : symbol.color) !== null && _a !== void 0 ? _a : "";
                    datapoint.lineColor = (_b = symbol === null || symbol === void 0 ? void 0 : symbol.lineColor) !== null && _b !== void 0 ? _b : "";
                    datapoint.areaColor = (_c = symbol === null || symbol === void 0 ? void 0 : symbol.areaColor) !== null && _c !== void 0 ? _c : "";
                    datapoint.mainPointColor = (_d = symbol === null || symbol === void 0 ? void 0 : symbol.mainPointColor) !== null && _d !== void 0 ? _d : "";
                    datapoint.secondaryPointColor = (_e = symbol === null || symbol === void 0 ? void 0 : symbol.secondaryPointColor) !== null && _e !== void 0 ? _e : "";
                });
                this.allData.forEach((datapoint, i) => {
                    var _a, _b, _c, _d, _e;
                    const symbol = this.symbols.find((s) => s.id === datapoint.symbol);
                    datapoint.color = (_a = symbol === null || symbol === void 0 ? void 0 : symbol.color) !== null && _a !== void 0 ? _a : "";
                    datapoint.lineColor = (_b = symbol === null || symbol === void 0 ? void 0 : symbol.lineColor) !== null && _b !== void 0 ? _b : "";
                    datapoint.areaColor = (_c = symbol === null || symbol === void 0 ? void 0 : symbol.areaColor) !== null && _c !== void 0 ? _c : "";
                    datapoint.mainPointColor = (_d = symbol === null || symbol === void 0 ? void 0 : symbol.mainPointColor) !== null && _d !== void 0 ? _d : "";
                    datapoint.secondaryPointColor = (_e = symbol === null || symbol === void 0 ? void 0 : symbol.secondaryPointColor) !== null && _e !== void 0 ? _e : "";
                });
            }
            createHTML() {
                var _a, _b;
                try {
                    this.rootElement = document.body.querySelector(`#${this.id}`);
                    if (this.rootElement == null) {
                        ``;
                        throw new Error("Container element not found.");
                    }
                    let selectedDatapointsExplanationStyle = this.series.length > 2
                        ? "display: none;"
                        : "margin-top: 16px; margin-bottom: 0px;";
                    if (this.onlyGraph && this.forceAllTime) {
                        selectedDatapointsExplanationStyle =
                            selectedDatapointsExplanationStyle.replace("margin-top: 16px;", "margin-top: 0px;");
                    }
                    let innerContainerStyle = "";
                    if (!((_b = (_a = CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.IsMobileDevice) !== null && _b !== void 0 ? _b : false)) {
                        innerContainerStyle = "cursor: pointer;";
                    }
                    let legendCssClass = "csrchartv2__csr-chart__legend chart__legend";
                    if (this.hasMultiplePlayers) {
                        legendCssClass += " csrchartv2__csr-chart__legend--multiple-players";
                    }
                    let xAxisScopesCssClass = "csrchartv2__csr-chart__x-axis-scopes";
                    const xAxisScopesInnerHtml = this.xAxisScopes
                        .map((scope) => {
                        const isSelected = this.xAxisScope == scope.value;
                        let cssClass = "csrchartv2__csr-chart__x-axis-scope";
                        if (isSelected) {
                            cssClass += " selected";
                        }
                        return `<div class="${cssClass}" data-value="${scope.value}">${scope.label}</div>`;
                    })
                        .join("");
                    let selectedDatapointsExplanationCssClass = "csr-chart__selected-datapoints-explanation";
                    if (this.onlyGraph) {
                        legendCssClass += " hiddenforced";
                        xAxisScopesCssClass += " hiddenforced";
                    }
                    let containerHtml = `   
        <div id="csr-chart-${this.id}" class="csrchartv2__csr-chart csrchartv2__chart">
            <div id="csr-chart-${this.id}-highlighted-datapoint-explanation" class=${selectedDatapointsExplanationCssClass}" style="${selectedDatapointsExplanationStyle}"></div>
            <div id="csr-chart-${this.id}-inner-container" class="csrchartv2__csr-chart__inner-container" style="${innerContainerStyle}">
            <div id="csr-chart-${this.id}-legend" class="${legendCssClass}"></div>
            <div id="csr-chart-${this.id}-x-axis-scopes" class="${xAxisScopesCssClass}">${xAxisScopesInnerHtml}</div>
            </div>
        </div>`;
                    const containerElementExists = document.body.querySelector(`#csr-chart-${this.id}`) != null;
                    if (!containerElementExists) {
                        this.rootElement.insertAdjacentHTML("beforeend", containerHtml);
                        this.containerElement = document.body.querySelector(`#csr-chart-${this.id}`);
                        this.highlightedDatapointsExplanationElement =
                            document.body.querySelector(`#csr-chart-${this.id}-highlighted-datapoint-explanation`);
                    }
                    if (!this.innerContainerElement) {
                        this.innerContainerElement = document.body.querySelector(`#csr-chart-${this.id}-inner-container`);
                    }
                    if (!this.innerContainerElement) {
                        throw new Error("Inner container element not found.");
                    }
                    if (this.containerElement == null) {
                        throw new Error("Container element not found.");
                    }
                    const innerChartContainerHtml = `<div class="csrchartv2__csr-chart__chart-container csrchartv2__chart-container" style="position: relative;"></div>`;
                    const innerChartContainerElementExists = document.body.querySelector(`#csr-chart-${this.id} .csrchartv2__csr-chart__chart-container`) != null;
                    if (!innerChartContainerElementExists) {
                        this.innerContainerElement.insertAdjacentHTML("beforeend", innerChartContainerHtml);
                        this.innerChartContainerElement = document.body.querySelector(`#csr-chart-${this.id} .csrchartv2__csr-chart__chart-container`);
                    }
                    if (this.innerChartContainerElement == null) {
                        throw new Error("Inner chart container element not found.");
                    }
                    let innerChartClasses = "csrchartv2__csr-chart__chart csrchartv2__chart__chart--scroll";
                    const innerChartHtml = `<div class="${innerChartClasses}" style="position: relative;"></div>`;
                    const innerChartElementExists = document.body.querySelector(`#csr-chart-${this.id} .csrchartv2__csr-chart__chart`) != null;
                    if (!innerChartElementExists) {
                        this.innerChartContainerElement.insertAdjacentHTML("beforeend", innerChartHtml);
                        this.innerChartElement = document.body.querySelector(`#csr-chart-${this.id} .csrchartv2__csr-chart__chart`);
                    }
                    if (this.innerChartElement == null) {
                        throw new Error("Inner chart element not found.");
                    }
                    let controlsCssClass = "csr-chart__controls";
                    if (this.onlyGraph) {
                        controlsCssClass += " hiddenforced";
                    }
                    const controlsHtml = ` 
        <div class="${controlsCssClass}">
        <button class="csr-chart__previous-week csr-chart__week-button" data-count="25">
        <<<
      </button>
        <button class="csr-chart__previous-week csr-chart__week-button" data-count="10">
        <<
      </button>
          <button class="csr-chart__previous-week csr-chart__week-button" data-count="1">
          <
          </button>
          <button class="csr-chart__next-week csr-chart__week-button" data-count="1">
          >
          </button>
          <button class="csr-chart__next-week csr-chart__week-button" data-count="10">
          >>
        </button>
        <button class="csr-chart__next-week csr-chart__week-button" data-count="25">
        >>>
      </button>
        </div>`;
                    const controlsElementExists = document.body.querySelector(`#csr-chart-${this.id} .csr-chart__controls`) != null;
                    if (!controlsElementExists) {
                        this.containerElement.insertAdjacentHTML("beforeend", controlsHtml);
                    }
                    let selectWeekCssClass = "csr-chart__select-week-container";
                    if (this.onlyGraph) {
                        selectWeekCssClass += " hiddenforced";
                    }
                    const selectWeeksContainerHtml = `<div class="${selectWeekCssClass}"></div>`;
                    let selectWeeksContainerElement = document.body.querySelector(`#csr-chart-${this.id} .csr-chart__select-week-container`);
                    if (!selectWeeksContainerElement) {
                        this.containerElement.insertAdjacentHTML("afterbegin", selectWeeksContainerHtml);
                        selectWeeksContainerElement = document.body.querySelector(`#csr-chart-${this.id} .csr-chart__select-week-container`);
                        const selectWeekHtml = `
          <div class="csr-chart__select-week">
          <select id="csr-chart-${this.id}-select-week" class="chart__select chart__select--date" title="Select a date to highlight">
          </select>
          </div>`;
                        selectWeeksContainerElement.innerHTML = selectWeekHtml;
                    }
                    this.weekSelectionElement = document.body.querySelector(`#csr-chart-${this.id}-select-week`);
                    // const xAxisScopeSelectionElementHtml = `<div class="csr-chart__select-x-axis-scope">
                    //   <select id="csr-chart-${this.id}-select-x-axis-visible-ticks-count" class="chart__select chart__select--entity" title="Select a date to highlight">
                    //   </select>
                    // </div>`;
                    // this.xAxisVisibleTicksCountSelectionElement =
                    //   document.body.querySelector(
                    //     `#csr-chart-${this.id}-select-x-axis-visible-ticks-count`
                    //   ) as HTMLElement | null;
                    // const selectsContainerHtml = `<div class="csr-chart__selects-container"></div>`;
                    // let datapointsCountSelectionElement = document.body.querySelector(
                    //   `#csr-chart-${this.id} .csr-chart__selects-container`
                    // );
                    // if (!datapointsCountSelectionElement) {
                    //   const weeksLabel = CS.Reass({
                    //     english: "weeks",
                    //     french: "semaines",
                    //     spanish: "semanas",
                    //   });
                    //   this.innerContainerElement.insertAdjacentHTML(
                    //     "beforebegin",
                    //     selectsContainerHtml
                    //   );
                    //   datapointsCountSelectionElement = document.body.querySelector(
                    //     `#csr-chart-${this.id} .csr-chart__selects-container`
                    //   ) as HTMLElement;
                    //   let datapointsCountSelectionHTML = `
                    //   <div class="csr-chart__select-number-of-datapoints">
                    //     <select id="csr-chart-${this.id}-select-number-of-datapoints" class="chart__select chart__select--entity" title="Select a date to highlight">`;
                    //   if (this.weeks.length >= 14) {
                    //     datapointsCountSelectionHTML += `<option value="14" selected>14 ${weeksLabel}</option>`;
                    //   }
                    //   if (this.weeks.length >= 24) {
                    //     datapointsCountSelectionHTML += `<option value="24">24 ${weeksLabel}</option>`;
                    //   }
                    //   if (this.weeks.length >= 32) {
                    //     datapointsCountSelectionHTML += `<option value="32">32 ${weeksLabel}</option>`;
                    //   }
                    //   if (this.weeks.length >= 52) {
                    //     datapointsCountSelectionHTML += `<option value="52">52 ${weeksLabel}</option>`;
                    //   }
                    //   const allTimeLabel = CS.Reass({
                    //     english: "All time",
                    //     french: "Tout le temps",
                    //     spanish: "Todo el tiempo",
                    //   });
                    //   datapointsCountSelectionHTML += `<option value="${this.weeks.length}">${allTimeLabel}</option>`;
                    //   datapointsCountSelectionHTML += `</select>
                    //   </div>`;
                    //   datapointsCountSelectionElement.innerHTML =
                    //     datapointsCountSelectionHTML;
                    // }
                    // this.selectNumberOfDatapointsElement = document.body.querySelector(
                    //   `#csr-chart-${this.id}-select-number-of-datapoints`
                    // ) as HTMLElement | null;
                }
                catch (error) {
                    console.error("Error while creating HTML.", error);
                }
            }
            removeHTML() {
                try {
                    if (this.rootElement) {
                        this.rootElement.innerHTML = "";
                    }
                    this.rootElement = null;
                    this.containerElement = null;
                    this.innerContainerElement = null;
                    this.innerChartContainerElement = null;
                    this.innerChartElement = null;
                    this.highlightedDatapointsExplanationElement = null;
                    this.weekSelectionElement = null;
                    // this.xAxisVisibleTicksCountSelectionElement = null;
                    this.selectNumberOfDatapointsElement = null;
                    this.legendElement = null;
                }
                catch (error) {
                    console.error("Error while removing HTML.", error);
                }
            }
            setChartDimensions() {
                return new Promise((resolve, reject) => {
                    try {
                        // The chart is often rendered within an accordion, which is hidden by default and animated when opened.
                        // By requesting an animation frame, we ensure that the chart is rendered after the accordion has been opened.
                        requestAnimationFrame(() => {
                            const spacing = this.getSpacingForXAxisTicks();
                            this.chartInnerWidth =
                                //this.chartMarginLeft +
                                spacing * this.weeks.length /*+ this.chartMarginRight*/;
                            return resolve();
                        });
                    }
                    catch (error) {
                        console.error("Error while setting chart dimensions.", error);
                        return reject(error);
                    }
                });
            }
            getSpacingForXAxisTicks() {
                try {
                    let spacing = this.fontSizeX * 2;
                    const containerElement = this.innerChartElement;
                    if (!containerElement) {
                        throw new Error("Container element not found.");
                    }
                    const containeRect = containerElement.getBoundingClientRect();
                    const area = containeRect.width - this.chartMarginLeft - this.chartMarginRight;
                    if (area <= 0) {
                        return spacing;
                    }
                    const range = this.visibleXAxisTicks - 1;
                    spacing = area / range;
                    return spacing;
                }
                catch (error) {
                    console.error("Error while getting spacing for x axis ticks.", error);
                    return this.fontSizeX * 2;
                }
            }
            setSelectedDatapoints(timestamp) {
                try {
                    Object.keys(this.datapointsByEntityBaseId).forEach((key) => {
                        let selectedDatapoints = [];
                        if (timestamp) {
                            const timestampDatapoints = this.datapointsByEntityBaseId[key].filter((datapoint) => {
                                return datapoint.timestamp === timestamp;
                            });
                            selectedDatapoints = timestampDatapoints;
                            if (!selectedDatapoints || !selectedDatapoints.length) {
                                const closestEarlierDatapoint = this.datapointsByEntityBaseId[key].reduce((acc, datapoint) => {
                                    const diff = timestamp - datapoint.timestamp;
                                    if (diff > 0 && diff < acc.diff) {
                                        acc.diff = diff;
                                        acc.datapoint = datapoint;
                                    }
                                    return acc;
                                }, {
                                    diff: Infinity,
                                    datapoint: null,
                                }).datapoint;
                                if (closestEarlierDatapoint) {
                                    const closestDatapointTimestamp = closestEarlierDatapoint.timestamp;
                                    const closestDatapoints = this.datapointsByEntityBaseId[key].filter((datapoint) => {
                                        return datapoint.timestamp === closestDatapointTimestamp;
                                    });
                                    selectedDatapoints = closestDatapoints;
                                }
                            }
                        }
                        else {
                            const lastDatapoint = this.datapointsByEntityBaseId[key][this.datapointsByEntityBaseId[key].length - 1];
                            const lastDatapointTimestamp = lastDatapoint.timestamp;
                            const lastDatapoints = this.datapointsByEntityBaseId[key].filter((datapoint) => {
                                return datapoint.timestamp === lastDatapointTimestamp;
                            });
                            selectedDatapoints = lastDatapoints;
                        }
                        if (selectedDatapoints.length) {
                            this.selectedDatapointsByEntityBaseId[key] = selectedDatapoints;
                        }
                        else {
                            this.selectedDatapointsByEntityBaseId[key] = [];
                        }
                    });
                    this.setDateSelectionValue();
                }
                catch (error) {
                    console.error("Error while resetting selected datapoints.", error);
                }
            }
            render(isResizing = false, resetScrollPosition = false) {
                return new Promise((resolve, reject) => {
                    var _a;
                    try {
                        this.setScale("x");
                        this.setScale("y");
                        if (this.xScale == null || this.yScale == null) {
                            throw new Error("Scales not found.");
                        }
                        this.setSVG();
                        this.setAxis("x");
                        this.setAxis("y");
                        this.drawFrozenCsrMarkers();
                        this.drawArea(); // Area should be drawn before lines to be behind them.
                        this.drawLines(); // Lines have to be drawn before points to avoid an error.
                        this.drawPoints();
                        this.setBisector();
                        this.setTooltip();
                        this.appendSVGNode();
                        this.setOverlay();
                        this.bindEvents();
                        this.setLegend();
                        this.setExplanationForSelectedDatapoints();
                        if (!isResizing) {
                            // We don't want to trigger the event if it's a resize rendering.
                            const timestamp = (_a = this.lastSelectedDatapoint) === null || _a === void 0 ? void 0 : _a.timestamp;
                            if (timestamp) {
                                const selectedWeek = this.weeks.find((week) => {
                                    return week.timestamp === timestamp;
                                });
                                if (selectedWeek) {
                                    this.Trigger(CSRChart.EventNames.WeekSelected, {
                                        jqueryEventObject: null,
                                        data: selectedWeek,
                                    });
                                }
                            }
                        }
                        if (resetScrollPosition) {
                            this.resetScrollPosition();
                        }
                        else {
                            this.scrollToSelectedDate();
                        }
                        return resolve();
                    }
                    catch (error) {
                        console.error("Error while rendering.");
                        return reject(error);
                    }
                });
            }
            drawFrozenCsrMarkers() {
                try {
                    if (!this.svg || !this.xScale) {
                        throw new Error("SVG element or xScale is not defined.");
                    }
                    this.svg.selectAll(".frozen-csr-marker").remove();
                    const imageSize = this.chartMarginTop;
                    this.data.forEach((datapoint) => {
                        if (datapoint.hasFrozenCsr) {
                            const xPosition = this.xScale(new Date(datapoint.timestamp));
                            this.svg
                                .append("line")
                                .attr("class", "frozen-csr-marker")
                                .attr("x1", xPosition)
                                .attr("y1", this.chartInnerHeight - this.chartMarginBottom)
                                .attr("x2", xPosition)
                                .attr("y2", this.chartMarginTop)
                                .attr("stroke", "rgba(124, 124, 124, 1)")
                                .attr("stroke-width", 2);
                            if (datapoint.frozenCsrEventImageUrl) {
                                const yPosition = 4;
                                const circleRadius = imageSize / 2 + 2;
                                this.svg
                                    .append("circle")
                                    .attr("class", "frozen-csr-marker")
                                    .attr("cx", xPosition)
                                    .attr("cy", yPosition + imageSize / 2)
                                    .attr("r", circleRadius)
                                    .attr("fill", "black")
                                    .attr("stroke", "rgba(124, 124, 124, 1)")
                                    .attr("stroke-width", 2);
                                this.svg
                                    .append("image")
                                    .attr("class", "frozen-csr-marker")
                                    .attr("x", xPosition - imageSize / 2)
                                    .attr("y", yPosition)
                                    .attr("width", imageSize)
                                    .attr("height", imageSize)
                                    .attr("xlink:href", datapoint.frozenCsrEventImageUrl)
                                    .attr("preserveAspectRatio", "xMidYMid slice")
                                    .attr("clip-path", "circle(50% at 50% 50%)");
                            }
                        }
                    });
                }
                catch (error) {
                    console.error("Error while drawing frozen CSR markers.", error);
                }
            }
            getTCSRDatapointsForCSRCalculationByEntityBaseId(entityBaseId, datapointCSR) {
                try {
                    const tcsrDatapoints = this.allData
                        .filter((datapoint) => datapoint.symbol.includes("TCSR") &&
                        datapoint.entityBaseId == entityBaseId)
                        .sort((a, b) => a.timestamp - b.timestamp);
                    if (datapointCSR == null) {
                        // if (!this.selectedDatapointsByEntityBaseId[entityBaseId].length) {
                        //   return [];
                        // }
                        // if (
                        //   !this.seriesByEntityBaseId[entityBaseId] ||
                        //   !this.seriesByEntityBaseId[entityBaseId].length
                        // ) {
                        //   return [];
                        // }
                        // const seriesTCSR = this.seriesByEntityBaseId[entityBaseId].filter(
                        //   (serie) => serie.key.includes("TCSR")
                        // );
                        // if (!seriesTCSR.length) {
                        //   return [];
                        // }
                        // const selectedDatapointsOfEntityBaseId =
                        //   this.selectedDatapointsByEntityBaseId[entityBaseId];
                        // if (!selectedDatapointsOfEntityBaseId.length) {
                        //   return [];
                        // }
                        // const lastSelectedDatapointOfEntityBaseId =
                        //   selectedDatapointsOfEntityBaseId[
                        //     selectedDatapointsOfEntityBaseId.length - 1
                        //   ];
                        // const timestamp = lastSelectedDatapointOfEntityBaseId.timestamp;
                        // seriesTCSR.forEach((serie) => {
                        //   let datapoints = serie.values.filter((datapoint) => {
                        //     return datapoint.timestamp <= timestamp;
                        //   });
                        //   if (datapoints.length > this.numberOfTCSRDatapointsToGetCSR) {
                        //     datapoints = datapoints.slice(
                        //       -this.numberOfTCSRDatapointsToGetCSR
                        //     );
                        //   }
                        //   result.push(...datapoints);
                        // });
                        // Find the last 12 datapoints that match the symbol "TCSR" and the entity base id.
                        const selectedDatapointsOfEntityBaseId = this.selectedDatapointsByEntityBaseId[entityBaseId];
                        if (!selectedDatapointsOfEntityBaseId ||
                            !selectedDatapointsOfEntityBaseId.length) {
                            return [];
                        }
                        const lastSelectedDatapointOfEntityBaseId = selectedDatapointsOfEntityBaseId[selectedDatapointsOfEntityBaseId.length - 1];
                        const timestamp = lastSelectedDatapointOfEntityBaseId.timestamp;
                        const result = tcsrDatapoints
                            .filter((datapoint) => {
                            return datapoint.timestamp <= timestamp;
                        })
                            .sort((a, b) => a.timestamp - b.timestamp)
                            .slice(-12);
                        return result;
                    }
                    else {
                        // if (
                        //   !this.seriesByEntityBaseId[entityBaseId] ||
                        //   !this.seriesByEntityBaseId[entityBaseId].length
                        // ) {
                        //   return [];
                        // }
                        // const seriesTCSR = this.seriesByEntityBaseId[entityBaseId].filter(
                        //   (serie) => serie.key.includes("TCSR")
                        // );
                        // if (!seriesTCSR.length) {
                        //   return [];
                        // }
                        // const timestamp = datapointCSR.timestamp;
                        // seriesTCSR.forEach((serie) => {
                        //   let datapoints = serie.values.filter((datapoint) => {
                        //     return datapoint.timestamp <= timestamp;
                        //   });
                        //   if (datapoints.length > this.numberOfTCSRDatapointsToGetCSR) {
                        //     datapoints = datapoints.slice(
                        //       -this.numberOfTCSRDatapointsToGetCSR
                        //     );
                        //   }
                        //   result.push(...datapoints);
                        // });
                        // Find the last 12 datapoints that match the symbol "TCSR" and the entity base id and are before the timestamp of the CSR datapoint.
                        const timestamp = datapointCSR.timestamp;
                        const result = tcsrDatapoints
                            .filter((datapoint) => {
                            return datapoint.timestamp <= timestamp;
                        })
                            .sort((a, b) => a.timestamp - b.timestamp)
                            .slice(-12);
                        return result;
                    }
                }
                catch (error) {
                    console.error("Error while getting TCSR datapoints for CSR calculation by entity base id.", error);
                    this.setState(ChartState.Error);
                    return [];
                }
            }
            setSelectOptions() {
                try {
                    this.setDateSelectionOptions();
                    // if (this.hasMultiplePlayers) {
                    //   this.setXAxisVisibleTicksCountSelectionOptions();
                    // }
                }
                catch (error) {
                    console.error("Error while rendering the select.", error);
                    this.setState(ChartState.Error);
                    return;
                }
            }
            setDateSelectionOptions() {
                try {
                    if (!this.series) {
                        throw new Error("Series not found.");
                    }
                    if (!this.weekSelectionElement) {
                        throw new Error("Select element not found.");
                    }
                    const select = document.getElementById(`csr-chart-${this.id}-select-week`);
                    if (!select) {
                        throw new Error("Select element not found.");
                    }
                    select.innerHTML = "";
                    const reversedWeeks = [...this.weeks].reverse();
                    // const prefix = CS.Raess({
                    //   french: "Semaine du",
                    //   english: "Week of",
                    //   spanish: "Semana del",
                    // });
                    for (let i = 0; i < reversedWeeks.length; i++) {
                        const week = reversedWeeks[i];
                        const { timestamp } = week;
                        const optionExists = select.querySelector(`option[value="${timestamp}"]`);
                        if (optionExists) {
                            continue;
                        }
                        const option = document.createElement("option");
                        option.value = timestamp.toString();
                        option.innerText =
                            // prefix +
                            // " " +
                            CS.Helper.AddSuffixToDay(week.date, week.date.toLocaleDateString(this.lang, {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                            }));
                        select.appendChild(option);
                        // if (
                        //   i >=
                        //   reversedWeeks.length - (this.numberOfTCSRDatapointsToGetCSR - 1)
                        // ) {
                        //   option.setAttribute("disabled", "true");
                        // }
                    }
                    if (this.preventInteraction) {
                        select.disabled = true;
                    }
                }
                catch (error) {
                    console.error("Error while setting date selection options.", error);
                }
            }
            // private setXAxisVisibleTicksCountSelectionOptions() {
            //   try {
            //     if (!this.series) {
            //       throw new Error("Series not found.");
            //     }
            //     // if (!this.xAxisVisibleTicksCountSelectionElement) {
            //     //   throw new Error("Select element not found.");
            //     // }
            //     const min = this.minimumVisibleXAxisTicks;
            //     const max = this.weeks.length;
            //     const steps = [min];
            //     if (max >= 24) {
            //       steps.push(24);
            //     }
            //     if (max >= 32) {
            //       steps.push(32);
            //     }
            //     if (max >= 52) {
            //       steps.push(52);
            //     }
            //     steps.push(max);
            //     const innerTextFormatter = (step: number) => {
            //       if (step === max) {
            //         return CS.Raess({
            //           french: "Afficher tout le temps",
            //           english: "Show all time",
            //           spanish: "Mostrar todo el tiempo",
            //         });
            //       }
            //       return CS.Raess({
            //         french: `Afficher ${step} semaines à la fois`,
            //         english: `Show ${step} weeks at a time`,
            //         spanish: `Mostrar ${step} semanas a la vez`,
            //       });
            //     };
            //     for (let i = 0; i < steps.length; i++) {
            //       const step = steps[i];
            //       const optionExists =
            //         this.xAxisVisibleTicksCountSelectionElement.querySelector(
            //           `option[value="${step}"]`
            //         );
            //       if (optionExists) {
            //         continue;
            //       }
            //       const option = document.createElement("option");
            //       option.value = step.toString();
            //       option.innerText = innerTextFormatter(step);
            //       this.xAxisVisibleTicksCountSelectionElement.appendChild(option);
            //     }
            //   } catch (error) {
            //     console.error(
            //       "Error while setting x axis visible ticks count options.",
            //       error
            //     );
            //   }
            // }
            setState(newState) {
                this.state = newState;
                // this.updateUI();
            }
            // private updateUI() {
            //   switch (this.state) {
            //     default:
            //       break;
            //   }
            // }
            setExplanationForSelectedDatapoints() {
                try {
                    if (this.highlightedDatapointsExplanationElement == null) {
                        throw new Error("Highlighted datapoint explanation element not found.");
                    }
                    if (!this.selectedDatapoints.length) {
                        this.highlightedDatapointsExplanationElement.innerHTML = "";
                        throw new Error("No selected datapoints.");
                    }
                    const datapointsCSR = this.selectedDatapoints.filter((datapoint) => {
                        return datapoint.symbol.includes("CompuSportRating");
                    });
                    if (!datapointsCSR.length) {
                        throw new Error("No CSR datapoints.");
                    }
                    const datapointCSR = datapointsCSR[0];
                    const datapointsTCSR = this.getTCSRDatapointsForCSRCalculationByEntityBaseId(this.entityBaseIds[0], datapointCSR);
                    const hasEnoughDatapointsToDisplayMathEquation = datapointsTCSR.length >= this.numberOfTCSRDatapointsToGetCSR;
                    let titlePrefix = "";
                    if (this.itsMe && this.entityBaseIds.length === 1) {
                        titlePrefix = datapointCSR.isCurrent
                            ? JSRess.ApproximationOfYourNextCSR
                            : JSRess.YourCSROnThisDate;
                    }
                    else {
                        titlePrefix = datapointCSR.isCurrent
                            ? JSRess.CSRApproximationOnThisDate
                            : JSRess.CSROnThisDate;
                    }
                    let title = `<div style="font-size: 1.35em;">${titlePrefix}</div>`;
                    if (this.onlyGraph && this.forceAllTime) {
                        title = `<div style="font-size: 0.85em; opacity: 0.7;">${JSRess.CSRComparison}</div>`;
                    }
                    const subtitleId = `csr-chart-${this.id}-subtitle`;
                    const subtitle = `<div id="${subtitleId}" style="font-size: 1.75em; cursor: pointer; display: flex; justify-content: center; align-items: center; gap: 8px;"><span style="color: ${this.mainCSRColor}; font-weight: 600; font-size: 1.1em;">${datapointCSR.value}</span><span style="    
        font-size: 0.6em;
        color: white;
        width: 1.1em;
        height: 1.1em;
        display: inline-flex;
        border: 2px solid white;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        opacity: 0.5;
        font-weight: 900;
        ">?</span></div>`;
                    let mathEquationResult = "";
                    for (let i = 0; i < datapointsTCSR.length; i++) {
                        const datapoint = datapointsTCSR[i];
                        const value = datapoint.value;
                        const color = datapoint.isCurrent ? "white" : this.mainTCSRColor;
                        const opacity = datapoint.isCurrent ? 0.8 : 1;
                        const fontWeight = datapoint.isCurrent ? 400 : 600;
                        const fontStyle = "normal";
                        if (i === 0) {
                            mathEquationResult += `(<span style="color: ${color}; font-weight: ${fontWeight}; opacity: ${opacity}; font-style: ${fontStyle};">${value}</span>`;
                        }
                        else {
                            mathEquationResult += ` + <span style="color: ${color}; font-weight: ${fontWeight}; opacity: ${opacity}; font-style: ${fontStyle};">${value}</span>`;
                        }
                        if (i === datapointsTCSR.length - 1) {
                            mathEquationResult += `)`;
                        }
                    }
                    const mathEquationId = `csr-chart-${this.id}-math-equation-result`;
                    const mathEquationClass = "csr-chart__math-equation-result";
                    const mathEquationStyle = `display: none; opacity: 0.7; margin-top: 12px; font-size: 1.1em; /*border-bottom: 1px solid rgba(255,255,255,0.7); margin-bottom: 4px; padding-bottom: 4px;*/`;
                    mathEquationResult += ` <span style="font-weight: 600; font-size: 1.2em; color: white;">/ ${datapointsTCSR.length}</span>`;
                    const mathEquationHTML = hasEnoughDatapointsToDisplayMathEquation
                        ? `<div id="${mathEquationId}" class="${mathEquationClass}" style="${mathEquationStyle}">${mathEquationResult}</div>`
                        : "";
                    this.highlightedDatapointsExplanationElement.innerHTML = `
          <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
          ${title}     
          ${this.hasMultiplePlayers ? "" : subtitle}    
          ${this.hasMultiplePlayers ? "" : mathEquationHTML}    
          </div>`;
                }
                catch (error) {
                    console.error("Error while setting highlighted datapoint explanation.");
                }
            }
            getStatName(statFieldId) {
                return statFieldId === "CompuSportRating" ? "CSR" : "T-CSR";
            }
            addCurrentCSRDatapointIfNeeded() {
                try {
                    this.entityBaseIds.forEach((entityBaseId) => {
                        const data = this.allData.filter((datapoint) => {
                            return datapoint.entityBaseId == entityBaseId;
                        });
                        const lastCSRDatapoint = data
                            .filter((datapoint) => {
                            return datapoint.symbol.includes("CompuSportRating");
                        })
                            .slice(-1)[0];
                        const datapointsForApproximateCSR = data
                            .filter((datapoint) => {
                            return datapoint.symbol.includes("TCSR");
                        })
                            .sort((a, b) => {
                            return a.timestamp - b.timestamp;
                        })
                            .slice(-this.numberOfTCSRDatapointsToGetCSR);
                        const lastTCSRDatapoint = datapointsForApproximateCSR[datapointsForApproximateCSR.length - 1];
                        const sameDate = lastCSRDatapoint.timestamp === lastTCSRDatapoint.timestamp;
                        if (!sameDate) {
                            // There should be exactly two datapoints for each date (one CSR and one TCSR).
                            // If there's only one datapoint for a date, either the CSR or the TCSR is missing.
                            this.lastDateIsMissingDatapoins = true;
                            if (lastTCSRDatapoint.timestamp > lastCSRDatapoint.timestamp) {
                                // If the last CSR datapoint's date is greater than the last TCSR datapoint's date,
                                // then the CSR is approximate.
                                this.lastValueIsCurrent = true;
                                // Create an approximate CSR datapoint.
                                const approximateCSR = Math.round(datapointsForApproximateCSR.reduce((acc, datapoint) => {
                                    return acc + datapoint.value;
                                }, 0) / datapointsForApproximateCSR.length);
                                const labelCSR = CS.Helper.formatString(JSRess.ApproximateCSROfX, lastCSRDatapoint.displayName);
                                const approximateCSRDatapoint = {
                                    symbol: lastCSRDatapoint.symbol,
                                    label: labelCSR,
                                    id: lastTCSRDatapoint.id,
                                    statName: lastCSRDatapoint.statName,
                                    displayName: lastCSRDatapoint.displayName,
                                    date: lastTCSRDatapoint.date,
                                    timestamp: lastTCSRDatapoint.timestamp,
                                    entityBaseId: entityBaseId,
                                    value: approximateCSR,
                                    image: lastCSRDatapoint.image,
                                    color: lastCSRDatapoint.color,
                                    lineColor: lastCSRDatapoint.lineColor,
                                    areaColor: lastCSRDatapoint.areaColor,
                                    mainPointColor: lastCSRDatapoint.mainPointColor,
                                    secondaryPointColor: lastCSRDatapoint.secondaryPointColor,
                                    pointRadius: lastCSRDatapoint.pointRadius,
                                    isCurrent: true,
                                };
                                this.data.push(approximateCSRDatapoint);
                                this.allData.push(approximateCSRDatapoint);
                                const labelTCSR = CS.Helper.formatString(JSRess.CurrentTCSROfX, lastCSRDatapoint.displayName);
                                this.data = this.data.map((datapoint, i) => {
                                    if (datapoint.timestamp === approximateCSRDatapoint.timestamp &&
                                        datapoint.symbol.includes("TCSR") &&
                                        datapoint.entityBaseId ===
                                            approximateCSRDatapoint.entityBaseId) {
                                        return Object.assign(Object.assign({}, datapoint), { label: labelTCSR, isCurrent: true });
                                    }
                                    return datapoint;
                                });
                                this.allData = this.allData.map((datapoint, i) => {
                                    if (datapoint.timestamp === approximateCSRDatapoint.timestamp &&
                                        datapoint.symbol.includes("TCSR") &&
                                        datapoint.entityBaseId ===
                                            approximateCSRDatapoint.entityBaseId) {
                                        return Object.assign(Object.assign({}, datapoint), { label: labelTCSR, isCurrent: true });
                                    }
                                    return datapoint;
                                });
                            }
                        }
                    });
                }
                catch (error) {
                    console.error("Error while adding current CSR datapoint.", error);
                }
            }
            setOverlay() {
                var _a, _b;
                try {
                    if (!this.innerChartContainerElement) {
                        throw new Error("Inner chart element not found.");
                    }
                    const overlayHTML = `<div class="csrchartv2__csr-chart__overlay"></div>`;
                    const overlayElementExists = document.body.querySelector(`#csr-chart-${this.id} .csrchartv2__csr-chart__overlay`) != null;
                    if (!overlayElementExists) {
                        this.innerChartContainerElement.insertAdjacentHTML("beforeend", overlayHTML);
                        this.chartOverlayElement = document.body.querySelector(`#csr-chart-${this.id} .csrchartv2__csr-chart__overlay`);
                    }
                    if (!this.chartOverlayElement || this.chartOverlayElement == null) {
                        throw new Error("Chart overlay element not found.");
                    }
                    this.chartOverlayElement.style.width = `${this.chartMarginLeft}px`;
                    this.chartOverlayElement.style.height = `${this.chartInnerHeight - this.chartMarginBottom + this.fontSizeY / 2}px`;
                    this.chartOverlayElement.style.pointerEvents = "none";
                    let backgroundColor = "";
                    let parent = this.containerElement;
                    while (parent) {
                        let parentBackgroundColor = (_b = (_a = parent === null || parent === void 0 ? void 0 : parent.computedStyleMap().get("background-color")) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "";
                        const isTransparentColor = parentBackgroundColor.includes("rgba(0, 0, 0, 0)");
                        if (isTransparentColor) {
                            parentBackgroundColor = "";
                        }
                        if (parentBackgroundColor) {
                            backgroundColor = parentBackgroundColor;
                            break;
                        }
                        parent = parent.parentElement;
                    }
                    this.chartOverlayElement.style.backgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "";
                }
                catch (error) {
                    console.error("Error while setting overlay width.", error);
                }
            }
            unRender() {
                return new Promise((resolve, reject) => {
                    try {
                        this.removeLines();
                        this.removeArea();
                        this.removeTooltip();
                        this.removeSVG();
                        return resolve();
                    }
                    catch (error) {
                        console.error("Error while un-rendering.");
                        return reject(error);
                    }
                });
            }
            destroy() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        yield this.unRender();
                        this.removeHTML();
                        this.eventsBound = false;
                        this.OnDispose();
                    }
                    catch (error) {
                        console.error("Error while destroying.", error);
                    }
                });
            }
            reset() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.resetData();
                        yield this.destroy();
                        yield this.initialize();
                    }
                    catch (error) {
                        console.error("Error while resetting.", error);
                    }
                });
            }
            reRender(isResizing = false) {
                return new Promise((resolve, reject) => {
                    try {
                        this.lastScrollLeft = this.getCurrentScrollLeft();
                        this.unRender()
                            .then(() => {
                            this.setSeries();
                            this.render(isResizing, true)
                                .then(() => {
                                this.scrollToSelectedDate();
                                return resolve();
                            })
                                .catch((error) => {
                                console.error(error);
                                return reject(error);
                            });
                        })
                            .catch((error) => {
                            console.error(error);
                            return reject(error);
                        });
                    }
                    catch (error) {
                        console.error("Error while re-rendering.");
                        return reject(error);
                    }
                });
            }
            setLegend() {
                try {
                    this.legendElement = document.body.querySelector(`#csr-chart-${this.id}-legend`);
                    if (this.legendElement == null) {
                        throw new Error("Legend element not found.");
                    }
                    if (!this.symbols.length) {
                        throw new Error("Players not found.");
                    }
                    const anyExistingLegendItems = this.legendElement.querySelectorAll(".csrchartv2__csr-chart__legend-item");
                    if (anyExistingLegendItems.length) {
                        this.legendElement.innerHTML = "";
                    }
                    this.symbols.forEach((symbol) => {
                        if (this.hasMultiplePlayers) {
                            if (symbol.id.includes("TCSR")) {
                                return;
                            }
                        }
                        let value = symbol.value;
                        let valueLabel = this.valueFormatter(value);
                        let valueStyle = "";
                        const color = symbol.color;
                        let itemLabel = symbol.statName;
                        const premiumLocked = symbol.premiumLocked;
                        if (this.hasMultiplePlayers) {
                            const selectedCSRDatapointsOfEntityBaseId = this.selectedDatapointsByEntityBaseId[symbol.entityBaseId].filter((datapoint) => {
                                return datapoint.symbol.includes("CompuSportRating");
                            });
                            const lastSelectedCSRDatapointOfEntityBaseId = selectedCSRDatapointsOfEntityBaseId[selectedCSRDatapointsOfEntityBaseId.length - 1];
                            if (lastSelectedCSRDatapointOfEntityBaseId) {
                                value = lastSelectedCSRDatapointOfEntityBaseId.value;
                                valueLabel = this.valueFormatter(value);
                            }
                            else {
                                value = 0;
                                valueLabel = "N/A";
                                valueStyle = "opacity: 0.5;";
                            }
                            itemLabel = symbol.entityName;
                        }
                        let valueHTML = `<div class="csrchartv2__csr-chart__legend-item__value chart__legend-item__value" data-value="${value}" style="${valueStyle}">${valueLabel}</div>`;
                        if (premiumLocked) {
                            // valueHTML = `<div class="csrchartv2__csr-chart__legend-item__value" data-value="${value}" style="${valueStyle}">
                            //   <div class="icon ic-cs-lock" style="color: white;"></div>
                            // </div>`;
                        }
                        let legendItemHtml = `
            <div class="csrchartv2__csr-chart__legend-item chart__legend-item" data-symbol="${symbol.id}">
              <div class="csrchartv2__csr-chart__legend-item__dot chart__legend-item__dot" style="background-color: ${color};"></div>
              <div class="csrchartv2__csr-chart__legend-item__label chart__legend-item__label">${itemLabel}</div>
              <span>&nbsp;</span>`;
                        if (this.hasMultiplePlayers) {
                            legendItemHtml += valueHTML;
                        }
                        legendItemHtml += `</div>`;
                        this.legendElement.insertAdjacentHTML("beforeend", legendItemHtml);
                    });
                    // sort legend items by value
                    if (this.hasMultiplePlayers) {
                        const legendItems = Array.from(this.legendElement.querySelectorAll(".csrchartv2__csr-chart__legend-item"));
                        legendItems.sort((a, b) => {
                            var _a, _b;
                            const valueA = parseFloat((_a = a.querySelector(".csrchartv2__csr-chart__legend-item__value").dataset.value) !== null && _a !== void 0 ? _a : "0");
                            const valueB = parseFloat((_b = b.querySelector(".csrchartv2__csr-chart__legend-item__value").dataset.value) !== null && _b !== void 0 ? _b : "0");
                            return valueB - valueA;
                        });
                        legendItems.forEach((item) => {
                            this.legendElement.appendChild(item);
                        });
                    }
                }
                catch (error) {
                    console.error("Error while setting legend.", error);
                }
            }
            setScale(axis) {
                var _a, _b;
                try {
                    if (axis === "x") {
                        //   this.xScale = d3
                        //     .scaleUtc()
                        //     .domain(d3.extent(this.flatData, (d) => d.date) as [Date, Date])
                        //     .range([
                        //       this.chartMarginLeft,
                        //       this.chartInnerWidth - this.chartMarginRight,
                        //     ])
                        //     .clamp(true);
                        this.xScale = d3
                            .scalePoint(this.weeks.map((d) => d.timestamp), [
                            this.chartMarginLeft,
                            this.chartInnerWidth - this.chartMarginRight,
                        ])
                            .range([
                            this.chartMarginLeft,
                            this.chartInnerWidth - this.chartMarginRight,
                        ]);
                        // .clamp(true);
                    }
                    else {
                        const min = (_a = this.forcedMin) !== null && _a !== void 0 ? _a : (d3.min(this.data, (d) => d.value) || 0);
                        const max = (_b = this.forcedMax) !== null && _b !== void 0 ? _b : (d3.max(this.data, (d) => d.value) || 0);
                        this.yScale = d3
                            .scaleLinear([min, max], [
                            this.chartInnerHeight - this.chartMarginBottom,
                            this.chartMarginTop,
                        ])
                            .nice();
                    }
                }
                catch (error) {
                    console.error(`Error while creating ${axis}-scale.`, error);
                }
            }
            removeSVG() {
                try {
                    if (this.svg == null) {
                        throw new Error("SVG not found.");
                    }
                    this.svg.remove();
                    if (this.svgOverlay == null) {
                        throw new Error("SVG overlay not found.");
                    }
                    this.svgOverlay.remove();
                }
                catch (error) {
                    console.error("Error while removing SVG node.", error);
                }
            }
            setSVG() {
                try {
                    this.svg = d3
                        .create("svg")
                        .attr("viewBox", [0, 0, this.chartInnerWidth, this.chartInnerHeight])
                        .attr("width", this.chartInnerWidth)
                        .attr("height", this.chartInnerHeight)
                        .attr("class", "csrchartv2__chart__svg")
                        .style("-webkit-tap-highlight-color", "transparent")
                        .style("overflow", "visible");
                    this.svgOverlay = d3
                        .create("svg")
                        .attr("viewBox", [0, 0, this.chartInnerWidth, this.chartInnerHeight])
                        .attr("width", this.chartInnerWidth)
                        .attr("height", this.chartInnerHeight)
                        .attr("class", "csrchartv2__chart__svg-overlay")
                        .style("-webkit-tap-highlight-color", "transparent")
                        .style("overflow", "visible");
                }
                catch (error) {
                    console.error("Error while creating SVG container.", error);
                    this.setState(ChartState.Error);
                }
            }
            setAxis(axis) {
                var _a, _b, _c;
                try {
                    if (this.xScale == null || this.yScale == null) {
                        throw new Error("Scales not found.");
                    }
                    if (axis === "x") {
                        (_a = this.svg) === null || _a === void 0 ? void 0 : _a.append("g").attr("transform", `translate(0,${this.chartInnerHeight - this.chartMarginBottom})`).call(d3
                            .axisBottom(this.xScale)
                            .ticks(this.chartInnerWidth / 80)
                            .tickSizeOuter(0)
                            .tickFormat((d, index) => {
                            if (isNaN(d) || d === null || d === undefined) {
                                return "";
                            }
                            const week = this.weeks.find((w) => w.timestamp === d.valueOf());
                            if (!week) {
                                return "";
                            }
                            if (this.visibleXAxisTicks > 128) {
                                if (index % 16 !== 0) {
                                    return "";
                                }
                            }
                            else if (this.visibleXAxisTicks > 96) {
                                if (index % 8 !== 0) {
                                    return "";
                                }
                            }
                            else if (this.visibleXAxisTicks > 64) {
                                if (index % 5 !== 0) {
                                    return "";
                                }
                            }
                            else if (this.visibleXAxisTicks > 48) {
                                if (index % 4 !== 0) {
                                    return "";
                                }
                            }
                            else if (this.visibleXAxisTicks > 32) {
                                if (index % 3 !== 0) {
                                    return "";
                                }
                            }
                            else if (this.visibleXAxisTicks > 16) {
                                if (index % 2 !== 0) {
                                    return "";
                                }
                            }
                            const year = week.date.getFullYear();
                            const month = week.date.getMonth() + 1;
                            const day = week.date.getDate();
                            return `${year}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}`;
                        })).call((g) => g.select(".domain").attr("class", "domain--x")).call((g) => g
                            .selectAll(".tick line")
                            .clone()
                            .attr("y2", -this.chartInnerHeight +
                            this.chartMarginBottom +
                            this.chartMarginTop)
                            .attr("stroke-opacity", 0.05)).call((g) => g
                            .selectAll(".tick")
                            .attr("class", (d) => `tick--x tick--x-${d.toString().replace(".", "-")}`)).selectAll("text").attr("transform", "translate(-13,5)rotate(-60)").attr("font-size", this.fontSizeX).attr("fill", this.textColorX).style("text-anchor", "end");
                        (_b = this.svgOverlay) === null || _b === void 0 ? void 0 : _b.style("position", "absolute").style("top", "0").style("left", "0").style("pointer-events", "none").style("z-index", "1").append("g").attr("transform", `translate(${this.chartMarginLeft},0)`).call(d3
                            .axisLeft(this.yScale)
                            .ticks(this.chartInnerHeight / 60)
                            .tickFormat((d, index) => {
                            return this.valueFormatter(d.valueOf());
                        })).call((g) => g
                            .selectAll(".tick line")
                            .clone()
                            .attr("x2", this.chartInnerWidth -
                            this.chartMarginLeft -
                            this.chartMarginRight)
                            .attr("stroke-opacity", 0.05)).selectAll("text").attr("font-size", this.fontSizeY).attr("fill", this.textColorY);
                    }
                    if (axis === "y") {
                        const yAxisOpacity = 1;
                        (_c = this.svg) === null || _c === void 0 ? void 0 : _c.append("g").style("opacity", yAxisOpacity).attr("transform", `translate(${this.chartMarginLeft},0)`).call(d3
                            .axisLeft(this.yScale)
                            .ticks(this.chartInnerHeight / 60)
                            .tickFormat((d, index) => {
                            return this.valueFormatter(d.valueOf());
                        })).call((g) => g.select(".domain").attr("class", "domain--y")).call((g) => g
                            .selectAll(".tick line")
                            .clone()
                            .attr("x2", this.chartInnerWidth -
                            this.chartMarginLeft -
                            this.chartMarginRight)
                            .attr("stroke-opacity", 0.05)).call((g) => g
                            .selectAll(".tick")
                            .attr("class", (d) => `tick--y tick--y-${d.toString().replace(".", "-")}`)).selectAll("text").attr("font-size", this.fontSizeY).attr("fill", this.textColorY);
                        this.svg
                            .select(".domain--x")
                            .attr("fill", "none")
                            .attr("stroke", this.domainLineColor);
                        this.svg
                            .selectAll(".tick--x line")
                            .attr("stroke", this.domainLineColor);
                        this.svg
                            .select(".domain--y")
                            .attr("fill", "none")
                            .attr("stroke", this.domainLineColor);
                        this.svg
                            .selectAll(".tick--y line")
                            .attr("stroke", this.domainLineColor);
                    }
                }
                catch (error) {
                    console.error(`Error while adding ${axis}-axis.`, error);
                }
            }
            removeLines() {
                try {
                    if (!this.serie) {
                        return;
                    }
                    this.serie.remove();
                }
                catch (error) {
                    console.error("Error while removing lines.", error);
                }
            }
            setBisector() {
                try {
                    this.bisect = d3.bisector((d) => d).center;
                }
                catch (error) {
                    console.error("Error while setting bisector.", error);
                }
            }
            removeArea() {
                var _a;
                try {
                    (_a = this.svg) === null || _a === void 0 ? void 0 : _a.selectAll(".area").remove();
                }
                catch (error) {
                    console.error("Error while removing area.", error);
                }
            }
            drawLines() {
                var _a, _b, _c, _d;
                try {
                    if (this.xScale == null || this.yScale == null) {
                        throw new Error("Scales not found.");
                    }
                    this.serie =
                        (_b = (_a = this.svg) === null || _a === void 0 ? void 0 : _a.append("g").selectAll("g").data(this.series).join("g")) !== null && _b !== void 0 ? _b : null;
                    const line = d3
                        .line()
                        .defined((d) => { var _a; return !isNaN((_a = d.value) !== null && _a !== void 0 ? _a : NaN); }) // Some values aren't available for some dates.
                        .x((d) => { var _a, _b; return (_b = (_a = this.xScale) === null || _a === void 0 ? void 0 : _a.call(this, d.timestamp)) !== null && _b !== void 0 ? _b : -1; })
                        .y((d) => { var _a, _b, _c; return (_c = (_a = this.yScale) === null || _a === void 0 ? void 0 : _a.call(this, (_b = d.value) !== null && _b !== void 0 ? _b : NaN)) !== null && _c !== void 0 ? _c : -1; });
                    // Draw lines for all datapoints, except the current ones
                    (_c = this.serie) === null || _c === void 0 ? void 0 : _c.append("path").attr("fill", "none").attr("stroke-linejoin", "round").attr("stroke-linecap", "round").attr("stroke-width", (d) => {
                        const isCSR = d.key.includes("CompuSportRating");
                        return isCSR ? this.strokeWidthCSR : this.strokeWidthTCSRSmall;
                    }).attr("stroke", (d) => {
                        return d.values[0].lineColor;
                    }).attr("d", (d) => {
                        return line(d.values.filter((d) => { var _a; return !isNaN((_a = d.value) !== null && _a !== void 0 ? _a : NaN) && d.value !== null && !d.isCurrent; }));
                    });
                    Object.keys(this.seriesByEntityBaseId).forEach((key) => {
                        var _a;
                        const entityBaseId = key;
                        // Draw line for T-CSR datapoints that are used for CSR calculation, except the current ones
                        const datapointsForHighlightedTCSRLine = this.getTCSRDatapointsForCSRCalculationByEntityBaseId(entityBaseId, this.selectedDatapointsByEntityBaseId[entityBaseId].find((d) => {
                            return d.symbol.includes("CompuSportRating");
                        }));
                        (_a = this.serie) === null || _a === void 0 ? void 0 : _a.append("path").attr("fill", "none").attr("stroke-linejoin", "round").attr("stroke-linecap", "round").attr("stroke-width", (d) => {
                            return this.strokeWidthTCSRLarge;
                        }).attr("stroke", (d) => {
                            return d.values[0].lineColor;
                        }).attr("d", (d) => {
                            return line(d.values.filter((d) => {
                                var _a;
                                const isTCSRDatapointForCSRCalculation = datapointsForHighlightedTCSRLine.find((datapoint) => datapoint.id === d.id);
                                return (isTCSRDatapointForCSRCalculation &&
                                    !isNaN((_a = d.value) !== null && _a !== void 0 ? _a : NaN) &&
                                    d.value !== null &&
                                    d.symbol.includes("TCSR") &&
                                    !d.isCurrent &&
                                    d.entityBaseId === entityBaseId);
                            }));
                        });
                    });
                    if (this.lastValueIsCurrent) {
                        // Draw dashed-line for the last two weeks if the last value is current
                        const lastTwoWeeks = this.weeks.slice(-2);
                        const lastTwoTimestamps = lastTwoWeeks.map((week) => week.timestamp);
                        (_d = this.serie) === null || _d === void 0 ? void 0 : _d.append("path").attr("fill", "none").attr("stroke-linejoin", "round").attr("stroke-linecap", "round").attr("stroke-width", (d) => {
                            this.strokeWidthDashedLine;
                        }).attr("stroke", (d) => {
                            return d.values[0].lineColor;
                        }).attr("stroke-dasharray", "5, 5").attr("d", (d) => {
                            return line(d.values.filter((d) => {
                                var _a;
                                return (!isNaN((_a = d.value) !== null && _a !== void 0 ? _a : NaN) &&
                                    d.value !== null &&
                                    lastTwoTimestamps.includes(d.timestamp));
                            }));
                        });
                    }
                }
                catch (error) {
                    console.error("Error while drawing lines.", error);
                }
            }
            drawPoints() {
                var _a;
                try {
                    let datapointsForHighlightedTCSRPointsByEntityBaseId = {};
                    this.entityBaseIds.forEach((entityBaseId) => {
                        const datapointsForHighlightedTCSRPoints = this.getTCSRDatapointsForCSRCalculationByEntityBaseId(entityBaseId);
                        datapointsForHighlightedTCSRPointsByEntityBaseId[entityBaseId] =
                            datapointsForHighlightedTCSRPoints;
                    });
                    // Add a point for each datapoint
                    (_a = this.serie) === null || _a === void 0 ? void 0 : _a.append("g").attr("stroke-linecap", "round").attr("stroke-linejoin", "round").attr("text-anchor", "middle").selectAll().data((d) => {
                        return d.values.filter((datapoint) => {
                            var _a;
                            return isNaN((_a = datapoint.value) !== null && _a !== void 0 ? _a : NaN) === false;
                        });
                    }).join("circle").attr("r", (d, i) => {
                        const isCSRDatapoint = d.symbol.includes("CompuSportRating");
                        return isCSRDatapoint
                            ? this.mainPointRadius
                            : this.secondaryPointRadius;
                    }).attr("fill", (d, i) => {
                        return d.mainPointColor;
                    }).attr("opacity", (d, i) => {
                        return 1;
                    }).attr("cx", (d) => {
                        if (this.xScale == null) {
                            return 0;
                        }
                        return this.xScale(d.timestamp);
                    }).attr("cy", (d) => {
                        if (this.yScale == null) {
                            return 0;
                        }
                        return this.yScale(d.value);
                    }).attr("class", (d) => {
                        let result = `csrchartv2__csr-chart__point csrchartv2__csr-chart__point--${d.symbol}`;
                        if (d.hasFrozenCsr) {
                            result += " csrchartv2__csr-chart__point--frozen";
                        }
                        return result;
                    }).attr("data-entity-base-id", (d) => {
                        return d.entityBaseId;
                    }).attr("data-timestamp", (d) => {
                        return d.timestamp;
                    }).clone().attr("r", (d, i) => {
                        const entityBaseId = d.entityBaseId;
                        const isCSRDatapoint = d.symbol.includes("CompuSportRating");
                        const isSelectedDatapoint = this.selectedDatapoints.find((datapoint) => {
                            return datapoint.id === d.id;
                        }) != null;
                        if (isSelectedDatapoint) {
                            if (d.symbol.includes("CompuSportRating")) {
                                if (d.timestamp ===
                                    datapointsForHighlightedTCSRPointsByEntityBaseId[entityBaseId][datapointsForHighlightedTCSRPointsByEntityBaseId[entityBaseId].length - 1].timestamp) {
                                    return this.mainPointRadius * 4;
                                }
                            }
                        }
                        const isTCSRDatapointForCSRCalculation = datapointsForHighlightedTCSRPointsByEntityBaseId[entityBaseId].find((datapoint) => datapoint.id === d.id) != null;
                        if (isTCSRDatapointForCSRCalculation) {
                            if (d.symbol.includes("TCSR")) {
                                return this.secondaryPointRadius * 3;
                            }
                        }
                        return isCSRDatapoint
                            ? this.mainPointRadius
                            : this.secondaryPointRadius;
                    }).attr("fill", (d, i) => {
                        return d.secondaryPointColor;
                    }).attr("class", (d) => {
                        return `csrchartv2__csr-chart__point-overlay csrchartv2__csr-chart__point-overlay--${d.symbol}`;
                    });
                }
                catch (error) {
                    console.error("Error while drawing points.", error);
                }
            }
            drawArea() {
                try {
                    if (this.xScale == null || this.yScale == null) {
                        throw new Error("Scales not found.");
                    }
                    const area = d3
                        .area()
                        .defined((d) => { var _a; return !isNaN((_a = d.value) !== null && _a !== void 0 ? _a : NaN); })
                        .x((d) => {
                        var _a, _b;
                        return (_b = (_a = this.xScale) === null || _a === void 0 ? void 0 : _a.call(this, d.timestamp)) !== null && _b !== void 0 ? _b : -1;
                    })
                        .y0((d) => {
                        var _a;
                        // const isCSRDatapoint = d.symbol.includes("CompuSportRating");
                        // if (isCSRDatapoint) {
                        //   const value = this.getYScaleValueForAreaOfDatapoint(d);
                        //   if (value) {
                        //     const y = this.yScale?.(value) as number;
                        //     return y;
                        //   }
                        // }
                        // if (this.hasMultiplePlayers) {
                        //   const isTCSRDatapoint = d.symbol.includes("TCSR");
                        //   if (isTCSRDatapoint) {
                        //     const timestamp = d.timestamp;
                        //     const timestampDatapoints = this.datapointsByDate[timestamp];
                        //     const matchingCSRDatapoint = timestampDatapoints.find(
                        //       (d) =>
                        //         d.symbol.includes("CompuSportRating") &&
                        //         d.timestamp === timestamp
                        //     );
                        //     if (matchingCSRDatapoint) {
                        //       const value = matchingCSRDatapoint.value;
                        //       if (value) {
                        //         const y = this.yScale?.(value) as number;
                        //         return y;
                        //       }
                        //     }
                        //   }
                        // }
                        return this.anyNegativeValues
                            ? (_a = this.yScale) === null || _a === void 0 ? void 0 : _a.call(this, 0)
                            : this.chartInnerHeight - this.chartMarginBottom;
                    })
                        .y1((d) => { var _a; return (_a = this.yScale) === null || _a === void 0 ? void 0 : _a.call(this, d.value); });
                    Object.keys(this.seriesByEntityBaseId).forEach((key) => {
                        var _a, _b, _c, _d;
                        const entityBaseId = key;
                        const csrLinearGradient = (_a = this.svg) === null || _a === void 0 ? void 0 : _a.append("defs").append("linearGradient").attr("id", `area-gradient-${entityBaseId}-${this.id}`).attr("x1", "0%").attr("y1", "0%").attr("x2", "0%").attr("y2", "100%");
                        const csrAreaColor = this.seriesByEntityBaseId[key][0].values[0].areaColor;
                        csrLinearGradient
                            .append("stop")
                            .attr("offset", "0%")
                            .attr("stop-color", csrAreaColor);
                        csrLinearGradient
                            .append("stop")
                            .attr("offset", "100%")
                            .attr("stop-color", csrAreaColor)
                            .attr("stop-opacity", 0.1);
                        const series = this.seriesByEntityBaseId[entityBaseId];
                        const datapointsForAreaCSR = ((_c = (_b = series.find((serie) => {
                            return serie.key.includes("CompuSportRating");
                        })) === null || _b === void 0 ? void 0 : _b.values) !== null && _c !== void 0 ? _c : []).filter((d) => {
                            return !d.isCurrent;
                        });
                        if (datapointsForAreaCSR.length) {
                            // Draw area for all CSR datapoints, except the current ones if there are any
                            series.forEach((serie, i) => {
                                var _a;
                                (_a = this.svg) === null || _a === void 0 ? void 0 : _a.append("path").attr("class", "area").attr("d", area(datapointsForAreaCSR)).attr("fill", `url(#area-gradient-${entityBaseId}-${this.id})`);
                            });
                        }
                        const datapointsForAreaTCSR = this.getTCSRDatapointsForCSRCalculationByEntityBaseId(entityBaseId);
                        if (datapointsForAreaTCSR.length) {
                            // Draw area for all T-CSR datapoints that are used for CSR calculation
                            const tcsrLineGradient = (_d = this.svg) === null || _d === void 0 ? void 0 : _d.append("defs").append("linearGradient").attr("id", `area-gradient-tcsr-${entityBaseId}-${this.id}`).attr("x1", "0%").attr("y1", "0%").attr("x2", "0%").attr("y2", "100%");
                            const tcsrAreaColor = datapointsForAreaTCSR[0].areaColor;
                            tcsrLineGradient
                                .append("stop")
                                .attr("offset", "0%")
                                .attr("stop-color", tcsrAreaColor);
                            tcsrLineGradient
                                .append("stop")
                                .attr("offset", "100%")
                                .attr("stop-color", tcsrAreaColor)
                                .attr("stop-opacity", 0.1);
                            series.forEach((serie, i) => {
                                var _a;
                                (_a = this.svg) === null || _a === void 0 ? void 0 : _a.append("path").attr("class", "area").attr("d", area(datapointsForAreaTCSR)).attr("fill", `url(#area-gradient-tcsr-${entityBaseId}-${this.id})`);
                            });
                        }
                    });
                }
                catch (error) {
                    console.error("Error while drawing area.", error);
                }
            }
            removeTooltip() {
                var _a;
                try {
                    (_a = this.tooltipV2) === null || _a === void 0 ? void 0 : _a.remove();
                }
                catch (error) {
                    console.error("Error while removing tooltip.", error);
                }
            }
            setTooltip() {
                var _a, _b;
                try {
                    this.tooltip = (_a = this.svg) === null || _a === void 0 ? void 0 : _a.append("g");
                    const tooltipV2HTML = document.createElement("div");
                    tooltipV2HTML.setAttribute("class", "csrchartv2__tooltip-v2");
                    (_b = this.innerChartContainerElement) === null || _b === void 0 ? void 0 : _b.appendChild(tooltipV2HTML);
                    this.tooltipV2 = d3.select(tooltipV2HTML);
                }
                catch (error) {
                    console.error("Error while adding tooltip.", error);
                }
            }
            appendSVGNode() {
                var _a, _b;
                try {
                    const svgNode = (_a = this.svg) === null || _a === void 0 ? void 0 : _a.node();
                    if (!(svgNode instanceof SVGSVGElement)) {
                        throw new Error("SVG node not found.");
                    }
                    if (!this.innerChartElement) {
                        throw new Error("Inner chart element not found.");
                    }
                    if (!this.innerChartContainerElement) {
                        throw new Error("Inner chart container element not found.");
                    }
                    this.innerChartElement.appendChild(svgNode);
                    const svgOverlayNode = (_b = this.svgOverlay) === null || _b === void 0 ? void 0 : _b.node();
                    if (!(svgOverlayNode instanceof SVGSVGElement)) {
                        throw new Error("SVG overlay node not found.");
                    }
                    this.innerChartContainerElement.appendChild(svgOverlayNode);
                }
                catch (error) {
                    console.error("Error while appending SVG node.", error);
                }
            }
            drawTooltip(closestDatapoint, datapointsOfDate, event) {
                var _a, _b, _c, _d;
                if (!this.tooltipV2) {
                    throw new Error("Tooltip not found.");
                }
                const dateLabel = CS.Helper.AddSuffixToDay(closestDatapoint.date, closestDatapoint.date.toLocaleDateString(this.lang, {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                }));
                // const title = CS.Reass({
                //   french: `Semaine du ${dateLabel}`,
                //   english: `Week of ${dateLabel}`,
                //   spanish: `Semana del ${dateLabel}`,
                // });
                const title = dateLabel;
                this.tooltipV2.style("opacity", 1).attr("class", "csrchartv2__tooltip-v2")
                    .html(`
          <div class="csrchartv2__tooltip-v2__title">${title}</div>
          <div class="csrchartv2__tooltip-v2__content">
          ${datapointsOfDate
                    .map((d) => {
                    var _a;
                    const symbol = this.symbols.find((s) => s.id === d.symbol);
                    const isTCSRPremiumLocked = ((_a = symbol === null || symbol === void 0 ? void 0 : symbol.premiumLocked) !== null && _a !== void 0 ? _a : false) && d.symbol.includes("TCSR");
                    if (!symbol || isTCSRPremiumLocked) {
                        return "";
                    }
                    const color = symbol.color;
                    return `<div class="csrchartv2__tooltip-v2__content__item">
              <div class="csrchartv2__tooltip-v2__content__item__color" style="background-color: ${color};"></div>
              <div class="csrchartv2__tooltip-v2__content__item__label">${d.label}</div>
              <div class="csrchartv2__tooltip-v2__content__item__value">${this.valueFormatter(d.value)}</div>
              ${d.hasFrozenCsr
                        ? '<div class="csrchartv2__tooltip-v2__content__item__event-name" style="margin-top: 8px;">' +
                            d.frozenCsrTooltipLabel +
                            "</div>"
                        : ""}
              </div>`;
                })
                    .join("")}

            </div>
            `);
                const tooltipOuterWidth = (_b = (_a = this.tooltipV2.node()) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
                const pointerXPos = d3.pointer(event, this.innerChartContainerElement)[0];
                const chartClientWidth = (_d = (_c = this.innerChartContainerElement) === null || _c === void 0 ? void 0 : _c.clientWidth) !== null && _d !== void 0 ? _d : 1;
                const isOnLeftSide = pointerXPos < chartClientWidth / 2;
                const tooltipXPos = isOnLeftSide
                    ? pointerXPos + 20
                    : pointerXPos - tooltipOuterWidth - 20;
                this.tooltipV2.style("left", `${tooltipXPos}px`);
            }
            setAndHighlightHoveredDatapoints(datapointsOfDate) {
                try {
                    if (!this.svg) {
                        throw new Error("SVG not found.");
                    }
                    this.hoveredDatapoints = datapointsOfDate;
                    this.svg
                        .selectAll(".csrchartv2__csr-chart__point")
                        .attr("opacity", (d) => {
                        const datapoint = d;
                        return datapointsOfDate.includes(datapoint) ? 1 : 0.5;
                    })
                        .attr("r", (d) => {
                        const datapoint = d;
                        return datapointsOfDate.includes(datapoint)
                            ? this.hoveredPointRadius
                            : datapoint.pointRadius;
                    });
                }
                catch (error) {
                    console.error("Error while hovered datapoints.", error);
                }
            }
            resetStyleOfHoveredDatapoints() {
                try {
                    if (!this.svg) {
                        throw new Error("SVG not found.");
                    }
                    // this.hoveredDatapoints = [];
                    this.svg
                        .selectAll(".csrchartv2__csr-chart__point")
                        .attr("opacity", 1)
                        .attr("r", (d) => {
                        const datapoint = d;
                        return datapoint.pointRadius;
                    });
                    this.svg
                        .selectAll(".csrchartv2__csr-chart__point-overlay")
                        .attr("opacity", 1);
                }
                catch (error) {
                    console.error("Error while resetting hovered datapoints.", error);
                }
            }
            hideTooltip() {
                if (!this.tooltipV2) {
                    throw new Error("Tooltip not found.");
                }
                this.tooltipV2.style("opacity", 0);
            }
            getSelectedDateScrollLeft(scrollContainer) {
                try {
                    const datapoint = this.selectedDatapoints[this.selectedDatapoints.length - 1];
                    const datapointElement = document.body.querySelector(`#csr-chart-${this.id} .csrchartv2__csr-chart__point-overlay[data-timestamp="${datapoint.timestamp}"]`);
                    if (!datapointElement) {
                        return;
                    }
                    const scrollContainerRect = scrollContainer.getBoundingClientRect();
                    const datapointElementRect = datapointElement.getBoundingClientRect();
                    const scrollLeft = scrollContainer.scrollLeft +
                        (datapointElementRect.left - scrollContainerRect.left) -
                        (scrollContainerRect.width - this.chartMarginRight - 16);
                    return scrollLeft;
                }
                catch (error) {
                    console.error("Error while getting selected datapoint scroll left.", error);
                    return 0;
                }
            }
            resetScrollPosition() {
                try {
                    if (!this.innerChartElement) {
                        return;
                    }
                    const scrollContainer = this.innerChartElement;
                    const scrollLeft = this.lastScrollLeft;
                    scrollContainer.scrollLeft = scrollLeft;
                }
                catch (error) {
                    console.error("Error while resetting scroll position.", error);
                }
            }
            scrollToSelectedDate() {
                try {
                    if (!this.innerChartElement) {
                        return;
                    }
                    const scrollContainer = this.innerChartElement;
                    const scrollLeft = this.getSelectedDateScrollLeft(scrollContainer);
                    setTimeout(() => {
                        scrollContainer.scrollTo({
                            left: scrollLeft,
                            behavior: "smooth",
                        });
                    }, 100);
                }
                catch (error) {
                    console.error("Error while scrolling to selected datapoint.", error);
                }
            }
            getCurrentScrollLeft() {
                try {
                    if (!this.innerChartElement) {
                        return;
                    }
                    const scrollContainer = this.innerChartElement;
                    return scrollContainer.scrollLeft;
                }
                catch (error) {
                    console.error("Error while getting current scroll left.", error);
                    return 0;
                }
            }
            setDateSelectionValue() {
                var _a;
                try {
                    const select = document.body.querySelector(`#csr-chart-${this.id}-select-week`);
                    if (select == null) {
                        throw new Error("Select element not found.");
                    }
                    const timestamp = (_a = this.lastSelectedDatapoint) === null || _a === void 0 ? void 0 : _a.timestamp;
                    if (!timestamp) {
                        return;
                    }
                    const option = select.querySelector(`option[value="${timestamp}"]`);
                    if (option == null) {
                        throw new Error("Option element not found.");
                    }
                    select.value = option.value;
                }
                catch (error) {
                    console.error("Error while setting date selection value.", error);
                }
            }
            bindEvents() {
                var _a, _b, _c, _d;
                try {
                    if (this.svg && !this.preventInteraction) {
                        this.svg
                            .on("pointerenter pointermove", this.handlePointerMove.bind(this))
                            .on("pointerleave", this.handlePointerLeave.bind(this))
                            .on("click", this.handleClick.bind(this));
                        //.on("touchstart", (event) => event.preventDefault())
                        //.on("touchmove", (event) => event.preventDefault());
                    }
                    if (this.eventsBound) {
                        return;
                    }
                    this.eventsBound = true;
                    //window.addEventListener("resize", this.handleResize.bind(this));
                    CS.DOM.$win.offon(`resize.${this.ControlId}`, this.handleResize.bind(this));
                    if (this.preventInteraction != true) {
                        this.$Control.offon(`click.${this.ControlId}-x-axis-scope`, ".csrchartv2__csr-chart__x-axis-scope", this.handleXAxisScopeClick.bind(this));
                        (_a = document.body
                            .querySelector(`#csr-chart-${this.id}-select-week`)) === null || _a === void 0 ? void 0 : _a.addEventListener("change", this.handleDateSelection.bind(this));
                        // document.body
                        //   .querySelector(
                        //     `#csr-chart-${this.id}-select-x-axis-visible-ticks-count`
                        //   )
                        //   ?.addEventListener(
                        //     "change",
                        //     this.handleXAxisVisibleTicksCountSelection.bind(this)
                        //   );
                        this.$Control.offon(`click.${this.ControlId}-subtitle`, `#csr-chart-${this.id}-subtitle`, this.handleSubtitleClick.bind(this));
                        (_b = document.body
                            .querySelectorAll(`#csr-chart-${this.id} .csr-chart__previous-week`)) === null || _b === void 0 ? void 0 : _b.forEach((element) => {
                            element.addEventListener("click", this.handleLeftArrowButtonClick.bind(this));
                        });
                        (_c = document.body
                            .querySelectorAll(`#csr-chart-${this.id} .csr-chart__next-week`)) === null || _c === void 0 ? void 0 : _c.forEach((element) => {
                            element.addEventListener("click", this.handleRightArrowButtonClick.bind(this));
                        });
                        (_d = document.body
                            .querySelector(`#csr-chart-${this.id}-select-number-of-datapoints`)) === null || _d === void 0 ? void 0 : _d.addEventListener("change", this.handleWeeksCountSelection.bind(this));
                    }
                }
                catch (error) {
                    console.error("Error while binding events.", error);
                }
            }
            handleXAxisScopeClick(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.state !== ChartState.Ready) {
                            return;
                        }
                        const $target = $(event.target);
                        const dataValue = $target.data("value");
                        const value = dataValue ? parseInt(dataValue) : 0;
                        if (value == 0) {
                            throw new Error("Invalid x-axis scope value of 0.");
                        }
                        if (this.xAxisScope == value) {
                            CS.Helper.log("CSRChart", "X-axis scope is already set to this value.", value);
                            return;
                        }
                        this.xAxisScope = value;
                        yield this.reset();
                    }
                    catch (error) {
                        console.error("Error while handling x-axis scope click.", error);
                    }
                });
            }
            handleResize() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.resizeTimeout) {
                            clearTimeout(this.resizeTimeout);
                        }
                        this.resizeTimeout = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                            this.resizeTimeout = null;
                            yield this.setChartDimensions();
                            yield this.reRender(true);
                        }), 500);
                    }
                    catch (error) {
                        console.error("Error while handling resize.", error);
                    }
                });
            }
            handleDateSelection(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.state !== ChartState.Ready) {
                            return;
                        }
                        const select = event.target;
                        const timestamp = parseInt(select.value);
                        this.setSelectedDatapoints(timestamp);
                        yield this.reRender();
                        this.setState(ChartState.Ready);
                    }
                    catch (error) {
                        console.error("Error while handling week selection change.", error);
                    }
                });
            }
            // private async handleXAxisVisibleTicksCountSelection(event: Event) {
            //   try {
            //     if (this.state !== ChartState.Ready) {
            //       return;
            //     }
            //     const select = event.target as HTMLSelectElement;
            //     const value = parseInt(select.value);
            //     this.setVisibleXAxisTicksCount(value);
            //     this.setPointRadiusOfEachDatapoint();
            //     await this.handleResize();
            //     this.setState(ChartState.Ready);
            //   } catch (error) {
            //     console.error(
            //       "Error while handling select number of visible ticks change."
            //     );
            //   }
            // }
            handleLeftArrowButtonClick(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.state !== ChartState.Ready) {
                            return;
                        }
                        this.setState(ChartState.Loading);
                        const dataCount = event.target.dataset.count;
                        const count = dataCount ? parseInt(dataCount) : 1;
                        const indexOfSelectedWeek = this.weeks.findIndex((week) => week.timestamp === this.selectedTimestamp);
                        let indexOfTargetWeek = indexOfSelectedWeek - count;
                        if (indexOfTargetWeek < 0) {
                            indexOfTargetWeek = 0;
                        }
                        const targetWeek = this.weeks[indexOfTargetWeek];
                        const timestamp = targetWeek.timestamp;
                        this.setSelectedDatapoints(timestamp);
                        yield this.reRender();
                        this.setState(ChartState.Ready);
                    }
                    catch (error) {
                        console.error("Error while handling previous week click.", error);
                        this.setState(ChartState.Error);
                    }
                });
            }
            handleSubtitleClick(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.state !== ChartState.Ready) {
                            return;
                        }
                        if (this.highlightedDatapointsExplanationElement == null) {
                            throw new Error("Highlighted datapoint explanation element not found.");
                        }
                        if (!this.selectedDatapoints.length) {
                            this.highlightedDatapointsExplanationElement.innerHTML = "";
                            throw new Error("No selected datapoints.");
                        }
                        const datapointsCSR = this.selectedDatapoints.filter((datapoint) => {
                            return datapoint.symbol.includes("CompuSportRating");
                        });
                        if (!datapointsCSR.length) {
                            throw new Error("No CSR datapoints.");
                        }
                        const datapointCSR = datapointsCSR[0];
                        const datapointsTCSR = this.getTCSRDatapointsForCSRCalculationByEntityBaseId(this.entityBaseIds[0], datapointCSR);
                        if (datapointsTCSR.length <= 1) {
                            return;
                        }
                        let htmlMessage = "<div>";
                        const lastDate = datapointsTCSR[datapointsTCSR.length - 1].date;
                        const lastDateLabel = CS.Helper.AddSuffixToDay(lastDate, lastDate.toLocaleDateString(this.lang, {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                        }));
                        const title = JSRess.CSRCalculationForTheFollowingDate;
                        htmlMessage += `<div class="csrchartv2__csr-chart__subtitle__title" style="">${title}</div>`;
                        htmlMessage += `<div class="csrchartv2__csr-chart__subtitle__title" style="margin-bottom: 16px; font-weight: 600;">${lastDateLabel}</div>`;
                        let sum = 0;
                        for (let i = 0; i < datapointsTCSR.length; i++) {
                            const datapoint = datapointsTCSR[i];
                            sum += datapoint.value;
                            const value = datapoint.value;
                            const color = datapoint.isCurrent ? "white" : this.mainTCSRColor;
                            const opacity = datapoint.isCurrent ? 0.8 : 1;
                            const fontWeight = datapoint.isCurrent ? 400 : 600;
                            const fontStyle = "normal";
                            const dateLabel = CS.Helper.AddSuffixToDay(datapoint.date, datapoint.date.toLocaleDateString(this.lang, {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                            }));
                            const label = datapoint.isCurrent
                                ? JSRess.ActualTCSR
                                : CS.Helper.formatString(JSRess.TCSROnXDate, dateLabel);
                            let datapointHTML = `<div class="csrchartv2__csr-chart__subtitle__datapoint">`;
                            let plusSignOpacity = 0;
                            if (i !== 0) {
                                plusSignOpacity = 1;
                            }
                            12;
                            datapointHTML += `<span class="csrchartv2__csr-chart__subtitle__datapoint__plus" style="opacity: ${plusSignOpacity};">+ </span>`;
                            datapointHTML += `<span class="csrchartv2__csr-chart__subtitle__datapoint__value" style="color: ${color}; font-weight: ${fontWeight}; font-style: ${fontStyle};">${datapoint.value}</span>`;
                            datapointHTML += `<span class="csrchartv2__csr-chart__subtitle__datapoint__label" style="font-style: italic; opacity: 0.5;">${label}</span>`;
                            datapointHTML += `</div>`;
                            htmlMessage += datapointHTML;
                        }
                        htmlMessage += `<div class="csrchartv2__csr-chart__subtitle__total" style="  margin-top: 8px;   font-weight: 600;/* color: white; */font-size: 1.2em;">= ${sum}</div>`;
                        htmlMessage += `<div class="csrchartv2__csr-chart__subtitle__final-equation" style="font-weight: 600; margin-top: 12px; font-size: 1.5em; color: white; display: flex; justify-content: flex-start; align-items: center; gap: 8px; background: rgba(255, 255, 255, 0.05); border-radius: 8px; padding: 4px 8px;">${sum} / ${datapointsTCSR.length} = <span style="color: ${this.mainCSRColor}; font-weight: 900;">${datapointCSR.value}</span></div>`;
                        htmlMessage += "</div>";
                        Controls.Popup.ShowMessage("", htmlMessage);
                    }
                    catch (error) {
                        console.error("Error while handling subtitle click.", error);
                    }
                });
            }
            handleRightArrowButtonClick(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.state !== ChartState.Ready) {
                            return;
                        }
                        this.setState(ChartState.Loading);
                        const dataCount = event.target.dataset.count;
                        const count = dataCount ? parseInt(dataCount) : 1;
                        const indexOfSelectedWeek = this.weeks.findIndex((week) => week.timestamp === this.selectedTimestamp);
                        let indexOfTargetWeek = indexOfSelectedWeek + count;
                        if (indexOfTargetWeek > this.weeks.length - 1) {
                            indexOfTargetWeek = this.weeks.length - 1;
                        }
                        const targetWeek = this.weeks[indexOfTargetWeek];
                        const timestamp = targetWeek.timestamp;
                        this.setSelectedDatapoints(timestamp);
                        yield this.reRender();
                        this.setState(ChartState.Ready);
                    }
                    catch (error) {
                        console.error("Error while handling next week click.", error);
                        this.setState(ChartState.Error);
                    }
                });
            }
            handleWeeksCountSelection(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                    }
                    catch (error) {
                        console.error("Error while handling select number of datapoints change.");
                    }
                });
            }
            handleClick() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.state !== ChartState.Ready) {
                            return;
                        }
                        if (!this.hoveredDatapoints.length) {
                            throw new Error("Highlighted datapoints not found.");
                        }
                        const timestamp = this.hoveredDatapoints[0].timestamp;
                        this.hideTooltip();
                        this.setState(ChartState.Loading);
                        this.setSelectedDatapoints(timestamp);
                        yield this.reRender();
                        this.setState(ChartState.Ready);
                    }
                    catch (error) {
                        console.error("Error while handling click.", error);
                        this.setState(ChartState.Ready);
                    }
                });
            }
            handlePointerMove(event) {
                try {
                    if (this.state !== ChartState.Ready) {
                        return;
                    }
                    if (this.xScale == null || this.yScale == null) {
                        throw new Error("Scales not found.");
                    }
                    let xPos = d3.pointer(event)[0];
                    const domain = this.xScale.domain();
                    const range = this.xScale.range();
                    const rangePoints = d3.range(range[0], range[1], this.xScale.step());
                    const timestamp = domain[this.bisect(rangePoints, xPos - this.xScale.step()) +
                        (xPos < this.xScale.step() * 2 ? 0 : 1)];
                    let datapoint = this.series[0].values.find((d) => {
                        if (!d || !d.date || timestamp == null) {
                            return false;
                        }
                        return d.timestamp == timestamp;
                    });
                    if (!datapoint) {
                        for (const serie of this.series) {
                            datapoint = serie.values.find((d) => {
                                if (!d || !d.date || timestamp == null) {
                                    return false;
                                }
                                return d.timestamp == timestamp;
                            });
                            if (datapoint) {
                                break;
                            }
                        }
                    }
                    if (!datapoint) {
                        this.hideTooltip();
                        return;
                    }
                    const datapointsOfDate = this.data
                        .filter((d) => {
                        return d.timestamp == datapoint.timestamp;
                    })
                        .sort((a, b) => {
                        return b.value - a.value;
                    });
                    this.drawTooltip(datapoint, datapointsOfDate, event);
                    this.setAndHighlightHoveredDatapoints(datapointsOfDate);
                }
                catch (error) {
                    console.error("Error while handling pointer move.", error);
                }
            }
            handlePointerLeave(event) {
                try {
                    if (this.state !== "ready") {
                        return;
                    }
                    this.hideTooltip();
                    this.resetStyleOfHoveredDatapoints();
                }
                catch (error) {
                    console.error("Error while handling pointer leave.", error);
                }
            }
        }
        Controls.CSRChart = CSRChart;
        (function (CSRChart) {
            class Events {
                static WeekSelected(param) {
                    Controls.RegisterEvent(CSRChart, EventNames.WeekSelected, param);
                }
            }
            CSRChart.Events = Events;
            class EventNames {
            }
            EventNames.WeekSelected = "week-selected";
            CSRChart.EventNames = EventNames;
        })(CSRChart = Controls.CSRChart || (Controls.CSRChart = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=CSRChart.js.map
